{
  "Actions": {
    "actions": "Działania",
    "back": "Powrót",
    "click here": "Kliknij tutaj",
    "collapse": "Zwiń",
    "expand": "Rozwiń",
    "go to vehicle": "Przejdź do pojazdu"
  },
  "Alert": {
    "Account is already activated": "Konto zostało już aktywowane.",
    "action failed": "Operacja nie powiodła się z powodu błędu",
    "add company card success": "Nowa karta firmowa została pomyślnie dodana.",
    "add driver success": "Kierowca został pomyślnie dodany",
    "add integration success": "Integracja została pomyślnie utworzona.",
    "add vehicle empty imei info": {
      "description": "Pojazd nie ma przypisanego numeru IMEI i nie będzie mógł pobierać plików. Dodaj prawidłowy numer IMEI, aby pobrać pliki pojazdu.",
      "title": "Pojazd został pomyślnie dodany, ale nie przypisano mu numeru IMEI."
    },
    "add vehicle success": "Pojazd został pomyślnie dodany",
    "An unhandled error occured while processing this request": "Podczas przetwarzania tego żądania wystąpił nieprzewidziany błąd.",
    "Another driver is registered under this card number.": "Pod tym numerem karty zarejestrowany jest inny kierowca.",
    "apply all driver schedules success": "Harmonogram został pomyślnie dodany do wszystkich kierowców.",
    "apply all vehicle schedules success": "Harmonogram został pomyślnie dodany do wszystkich pojazdów.",
    "apply driver schedules success": "Harmonogram został pomyślnie dodany do {{resourceCount}} kierowców.",
    "apply vehicle schedules success": "Harmonogram został pomyślnie dodany do {{resourceCount}} pojazdów.",
    "cancel invitation success": "Zaproszenie zostało pomyślnie anulowane.",
    "Card number must be 16 characters in length.": "Identyfikator kierowcy musi mieć długość 16 znaków.",
    "CCA file download success": "Aplikacja Company Card Authenticator została pomyślnie pobrana.",
    "Comment must not be longer than 255 characters.": "Dopuszczalna liczba znaków w opisie wynosi 255.",
    "Company card with such ID already exists.": "Karta firmowa z takim identyfikatorem już istnieje.",
    "Company card with such name already exists.": "Karta firmowa o tej nazwie już istnieje.",
    "Company not found": "Nie znaleziono firmy.",
    "Company not found.": "Nie znaleziono firmy.",
    "Company with this LZ client code already exists.": "Firma o tym kodzie Teltonika już istnieje.",
    "create client company success": "Pomyślnie utworzono nową firmę klienta.",
    "create company success": "Firma została pomyślnie utworzona.",
    "create schedule success": "Nowy harmonogram został pomyślnie utworzony.",
    "credits overdraft activated": "Kredyt w rachunku bieżącym został pomyślnie aktywowany",
    "credits overdraft deactivated": "Kredyt w rachunku bieżącym został pomyślnie deaktywowany",
    "disable integration success": "Integracja została pomyślnie wyłączona.",
    "Driver duplication.": "Duplikacja kierowców.",
    "Driver name contains invalid characters.": "Nazwisko kierowcy zawiera nieprawidłowe znaki.",
    "Driver name must be 3-50 characters long.": "Nazwa kierowcy musi mieć długość od 3 do 50 znaków.",
    "Driver with such card number already exists.": "Identyfikator kierowcy już istnieje.",
    "Drivers schedules were not found": "Nie znaleziono harmonogramów kierowców.",
    "edit company card success": "Karta firmowa została pomyślnie edytowana.",
    "edit integration success": "Integracja została pomyślnie edytowana.",
    "edit schedule success": "Harmonogram został pomyślnie edytowany.",
    "edit user description": "Zmiany zaczną obowiązywać po wylogowaniu się użytkownika, który wprowadził zmiany.",
    "Email recipient was not found.": "Nie znaleziono odbiorcy wiadomości e-mail.",
    "email transfer edit recipient success": "Adresat wiadomości e-mail został pomyślnie edytowany.",
    "email transfer new recipient success": "Odbiorca wiadomości e-mail został pomyślnie dodany.",
    "email transfer remove recipient success": "Odbiorca wiadomości e-mail został pomyślnie usunięty.",
    "enable integration success": "Integracja została pomyślnie włączona.",
    "error": {
      "import failed": "Nie udało się zaimportować pliku. Usuń plik, upewnij się, że dane są zgodne z wymaganą strukturą, a następnie prześlij plik ponownie.",
      "import failed description": "Usuń plik, upewnij się, że dane są zgodne z wymaganą strukturą, a następnie prześlij plik ponownie.",
      "import failed title": "Import nie powiódł się. Dane nie odpowiadają strukturze pliku."
    },
    "general settings update success": "Ustawienia zostały pomyślnie zmienione.",
    "global schedule success": "Globalny harmonogram został pomyślnie utworzony.",
    "Id must be of digits and letters only": "Identyfikator musi składać się wyłącznie z cyfr i liter",
    "Id must be of length 6 to 8": "Identyfikator musi mieć długość od 6 do 8 znaków",
    "Imei must be 15 characters long.": "Numer IMEI musi mieć długość 15 znaków.",
    "Imei must be numeric.": "W polu IMEI dozwolone są wyłącznie wartości liczbowe.",
    "integration editing cancelled": "Edytowanie integracji zostało anulowane.",
    "Integration is disabled. Enable it first before retrying": "Integracja jest wyłączona. Włącz ją przed ponowną próbą.",
    "Invalid email address": "Nieprawidłowy adres e-mail.",
    "Invalid format.": "Nieprawidłowy format pliku",
    "LZ client code not found.": "Nie znaleziono kodu Teltonika.",
    "move company success": "Firma „{{sourceCompany}}” została pomyślnie przeniesiona do „{{targetCompany}}”.",
    "New name must be different from the current name.": "Nowa nazwa musi różnić się od obecnej nazwy.",
    "news created": "Wiadomość została pomyślnie utworzona.",
    "news deleted": "Wiadomość została pomyślnie usunięta.",
    "news edited": "Wiadomość została pomyślnie edytowana.",
    "news published": "Wiadomość opublikowana pomyślnie.",
    "Number must be provided.": "Należy podać numer.",
    "Number must not be longer than 30 characters.": "Dopuszczalna liczba znaków w numerze pojazdu wynosi 30.",
    "One or more selected companies have child companies and cannot be deleted.": "Jedna lub więcej wybranych firm posiada spółki zależne i nie można ich usunąć.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "Podczas analizowania pliku CSV wystąpił co najmniej jeden błąd walidacji. Proszę skorzystać z pliku szablonu jako wzoru.",
    "One or more validation errors occured.": "Wystąpił co najmniej jeden błąd walidacji.",
    "quick schedule created": {
      "description": {
        "drivers": "Pobieranie danych rozpocznie się, gdy tylko zostanie wykryte połączenie kierowcy z TachoSync.",
        "vehicles": "Pobieranie danych rozpocznie się, gdy tylko zostanie wykryte połączenie pojazdu z TachoSync."
      },
      "title": "Szybki harmonogram został pomyślnie utworzony.",
      "title multiple drivers": "Szybki harmonogram został pomyślnie utworzony dla {{driverNum}} kierowców.",
      "title multiple vehicles": "Szybki harmonogram został pomyślnie utworzony dla {{vehicleNum}} pojazdów.",
      "title single driver": "Szybki harmonogram został pomyślnie utworzony."
    },
    "Quick schedule for vehicle is already created.": "Szybki harmonogram dla pojazdu został już utworzony.",
    "Quick schedule is already assigned to the driver.": "Kierowca ma już przypisany harmonogram.",
    "remove company card success": "Karta firmowa została pomyślnie usunięta.",
    "resend invitation success": "Zaproszenie zostało ponownie wysłane.",
    "retry integration success": "Integracja „{{integrationName}}” została pomyślnie nawiązana.",
    "retry interrupted integration success": "Integracja „{{integrationName}}” ponowi próbę synchronizacji pominiętych plików. Proszę sprawdzić status później.",
    "session expired": "Twoja sesja wygasła. Zaloguj się ponownie.",
    "successfully activate vehicle multiple": "Pojazdy {{resourceString}} zostały pomyślnie aktywowane.",
    "successfully activate vehicle single": "Pojazd został pomyślnie aktywowany.",
    "successfully assigned schedules": {
      "multiple": "Harmonogramy zostały pomyślnie przypisane.",
      "single": "Harmonogram został pomyślnie przypisany."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} pojazdów pomyślnie wyłączono.",
    "successfully deactivate vehicle single": "Pojazd został pomyślnie wyłączony.",
    "successfully deleted": "{{resourceString}} został pomyślnie usunięty.",
    "successfully edited": "{{resourceString}} został pomyślnie edytowany.",
    "successfully exported": "$t(General##{{tableName}}) pomyślnie wyeksportowano.",
    "successfully imported": "{{resourceString}} został pomyślnie zaimportowany.",
    "successfully move vehicles multiple": "{{resourceString}} zostały pomyślnie przeniesione do {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} został pomyślnie przeniesiony do {{companyString}}.",
    "successfully remove driver schedules multiple": "Harmonogramy zostały pomyślnie usunięte z kierowców {{resourceString}}.",
    "successfully remove driver schedules single": "Harmonogramy zostały pomyślnie usunięte z kierowcy {{resourceString}}.",
    "successfully remove vehicle schedules multiple": "Harmonogramy zostały pomyślnie usunięte z pojazdów {{resourceString}}.",
    "successfully remove vehicle schedules single": "Harmonogramy zostały pomyślnie usunięte z pojazdu {{resourceString}}.",
    "successfully removed": "{{resourceString}} został pomyślnie usunięty.",
    "The company with such name already exists.": "Firma o tej nazwie już istnieje.",
    "User is already invited.": "Użytkownik został już zaproszony.",
    "User is not invited": "Użytkownik nie został zaproszony.",
    "Vehicle duplication.": "Duplikacja pojazdu.",
    "Vehicle number contains invalid characters.": "Numer pojazdu zawiera nieprawidłowe znaki.",
    "Vehicle schedule was not found": "Nie znaleziono harmonogramu pojazdu.",
    "Vehicle successfully activated": "Pojazd został pomyślnie aktywowany.",
    "Vehicle with such IMEI already exists.": "Pojazd o tym numerze IMEI już istnieje",
    "Vehicle with such Imei number already exists.": "Numer IMEI już istnieje.",
    "Vehicle with such number (VRN) already exists.": "Pojazd o tym numerze rejestracyjnym już istnieje",
    "Vehicles schedules were not found": "Nie znaleziono harmonogramów pojazdów.",
    "You cannot delete a company you are a member of.": "Nie można usunąć aktualnie wybranej firmy. Wybierz inną firmę i powtórz operację."
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Sprawdź swoją aplikację uwierzytelniającą",
      "check email": "Sprawdź swoją skrzynkę e-mail",
      "code required": "Wymagany kod weryfikacyjny.",
      "code sent to email": "Kod wysłany na Twój adres e-mail",
      "code valid": "Kod jest ważny przez kilka minut.",
      "enter code below": "i wprowadź poniższy kod, aby się zalogować."
    },
    "account verification description": "Wymagany kod weryfikacyjny. Sprawdź swoją aplikację uwierzytelniającą i wprowadź poniższy kod, aby się zalogować.",
    "authenticator": "Aplikacja do uwierzytelniania",
    "authenticator verification description": "Wymagany kod weryfikacyjny. Sprawdź swoją aplikację uwierzytelniającą i wprowadź poniższy kod, aby się zalogować.",
    "back to sign in screen": "Powrót do ekranu logowania",
    "check email": "Sprawdź swoją skrzynkę odbiorczą i kliknij otrzymany link, aby zresetować hasło.",
    "community forum": "Forum wsparcia społeczności",
    "contact us": "Skontaktuj się z nami",
    "create password": "Utwórz hasło",
    "did not receive": "Nie otrzymałeś linku?",
    "do not have account": "Nie masz jeszcze konta?",
    "email": "E-mail",
    "enter current password": "Wprowadź aktualne hasło",
    "enter email": "Wpisz poniżej swój zarejestrowany adres e-mail, aby otrzymać instrukcje dotyczące resetowania hasła.",
    "enter here": "Wpisz tutaj",
    "enter new password": "Wprowadź nowe hasło",
    "enter numbers only": "Proszę wprowadzać wyłącznie cyfry (0–9)",
    "example": "Np.:",
    "failed to login": "Podany adres e-mail lub hasło są nieprawidłowe.",
    "forgot password": "Nie pamiętasz hasła?",
    "forgot your password": "Nie pamiętasz hasła?",
    "go to login": "Przejdź do logowania",
    "google authenticator": "Google Authenticator",
    "hide password": "Ukryj hasło",
    "invalid email format": "Nieprawidłowy format adresu e-mail",
    "invalid password format": "Nieprawidłowy format hasła",
    "Invitation expired": "Link zaproszenia wygasł lub został anulowany.",
    "link sent": "Link został wysłany!",
    "login title": "Zaloguj się",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Nowe hasło",
    "password": "Hasło",
    "password changed": "Hasło zostało pomyślnie zmienione.",
    "privacy policy": "Korzystając z <1>TachoSync</1>, wyrażasz zgodę na naszą <3>Politykę </3>prywatności.",
    "remember password": "Pamiętasz swoje hasło?",
    "repeat new password": "Powtórz nowe hasło",
    "repeat password": "Powtórz hasło",
    "required": "Wymagane",
    "resend": "Wyślij ponownie",
    "reset password": "Zresetuj hasło",
    "send reset link": "Wyślij link do resetowania",
    "show password": "Pokaż hasło",
    "sign in": "Zaloguj się",
    "sign in to tacho": "Zaloguj się na swoje\nkonto TachoSync",
    "sign out": "Wyloguj się",
    "sign up": "Zarejestruj się",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Rozumiem i akceptuję <1>Warunki świadczenia usług</1> Teltonika oraz <2>Umowę o przetwarzaniu danych </2>.",
    "wiki": "Baza wiedzy Wiki Telematics"
  },
  "Button": {
    "accept": "Akceptuj",
    "accept all": "Zaakceptuj wszystko",
    "accept selected": "Zaakceptuj wybrane",
    "actions": "Działania",
    "activate": "Aktywuj",
    "add": "Dodaj",
    "add driver": "Dodaj kierowcę",
    "add integration": "Dodaj integrację",
    "add to schedule": "Dodaj do harmonogramu",
    "add vehicle": "Dodaj pojazd",
    "all drivers": "Wszyscy kierowcy",
    "all vehicles": "Wszystkie pojazdy",
    "apply": "Zastosuj",
    "assign": "Przypisz",
    "back": "Powrót",
    "back to sign in": "Powrót do logowania",
    "cancel": "Anuluj",
    "change": "Zmień",
    "child company": "Spółka zależna",
    "clear": "Wyczyść",
    "clear all": "Wyczyść wszystko",
    "close": "Zamknij",
    "confirm": "Potwierdź",
    "continue": "Kontynuuj",
    "continue to TachoSync": "Przejdź do TachoSync",
    "copied": "Skopiowano",
    "copy to clipboard": "Kopiuj do schowka",
    "create": "Utwórz",
    "create schedule": "Utwórz harmonogram",
    "deactivate": "Wyłącz",
    "default view": "Widok domyślny",
    "delete": "Usuń",
    "deselect all": "Odznacz wszystko",
    "disable": "Wyłącz",
    "don't apply": "Nie stosować",
    "download": "Pobierz",
    "edit": "Edytuj",
    "edit driver": "Edytuj kierowcę",
    "edit integration": "Edytuj integrację",
    "edit vehicle": "Edytuj pojazd",
    "enable": "Włącz",
    "export": "Eksport",
    "export drivers": "Eksport kierowców",
    "export vehicles": "Eksport pojazdów",
    "file settings": "Ustawienia plików",
    "filtered": "Przefiltrowane",
    "filters": "Filtry",
    "find device": "Znajdź urządzenie",
    "finish": "Zakończ",
    "first page": "Strona główna",
    "generate": "Generuj",
    "generate report": "Generuj raport",
    "get started": "Rozpocznij",
    "go back": "Wróć",
    "import": "Import",
    "import drivers": "Import kierowców",
    "import vehicles": "Import pojazdów",
    "inline actions": {
      "cancel invitation": "Anuluj zaproszenie",
      "download file driver": "Pobierz",
      "download file vehicle": "Pobierz",
      "download monitoring": "Monitorowanie pobierania",
      "download status": "Stan pobierania",
      "edit analysis provider": "Edytuj",
      "edit company": "Edytuj firmę",
      "edit driver": "Edytuj kierowcę",
      "edit integration": "Edytuj integrację",
      "edit user": "Edytuj użytkownika",
      "edit vehicle": "Edytuj pojazd",
      "resend invitation": "Wyślij ponownie zaproszenie",
      "retry analysis provider": "Ponów próbę",
      "retry integration": "Ponów próbę"
    },
    "invite": "Zaproś",
    "invite user": "Zaproś użytkownika",
    "history": "Historia",
    "last page": "Ostatnia strona",
    "max download files": "Jednorazowo można pobrać tylko {{maxNumber}} plików.",
    "more actions": "Więcej działań",
    "more filters": "Więcej filtrów",
    "more options": "Więcej opcji",
    "move": "Przenieś",
    "new client": "Nowy klient",
    "next": "Dalej",
    "next month": "Następny miesiąc",
    "next page": "Następna strona",
    "only essential": "Tylko niezbędne",
    "open TachoSync": "Otwórz TachoSync",
    "pages of": "z {{total}}",
    "pause": "Wstrzymaj",
    "previous": "Poprzedni",
    "previous month": "Poprzedni miesiąc",
    "previous page": "Poprzednia strona",
    "quick schedule": "Szybki harmonogram",
    "refresh page": "Odśwież stronę",
    "reject all": "Odrzuć wszystko",
    "remove": "Usuń",
    "remove schedules": "Usuń harmonogramy",
    "reset": "Resetuj",
    "reset to default": "Przywróć ustawienia domyślne",
    "resume": "Wznowienie",
    "return home": "Powrót",
    "rows selected": "{{count}} Wybrane",
    "save": "Zapisz",
    "schedules": "Harmonogramy",
    "select image": "Wybierz zdjęcie",
    "select rows": "Wybierz wiersze",
    "selected": "Wybrane",
    "send code": "Wyślij kod",
    "settings": "Ustawienia",
    "table view": "Widok tabeli",
    "testing connection": "Testowanie połączenia...",
    "verify": "Zweryfikuj",
    "yes": "Tak"
  },
  "Company cards": {
    "add new": "Dodaj nowy",
    "badge tooltip": {
      "Disconnected": "Utracono połączenie z TachoSync.\nOstatnie połączenie {{connectionDate}}.",
      "Expired": "Karta została dezaktywowana z powodu wygaśnięcia ważności.",
      "Inactive": "Nigdy nie nawiązano pomyślnego połączenia z TachoSync.",
      "Online": "Połączono z TachoSync i trwa komunikacja."
    },
    "card expired": "Karta straciła ważność: {{date}}",
    "card id": "ID karty",
    "card number": "Numer karty",
    "card number tooltip": "Numer karty zostanie wyświetlony po pierwszej pomyślnej autoryzacji.",
    "cca version": "Wersja CCA",
    "company card id": "Identyfikator karty firmowej",
    "edit card": "Edytuj kartę",
    "edit company card": "Edytuj kartę przedsiębiorstwa",
    "expiry": "Wygasanie",
    "expiry date": "Data ważności: {{date}}",
    "expiry tooltip": "Data ważności karty zostanie wyświetlona po pierwszej pomyślnej autoryzacji.",
    "latest version": "Najnowsze",
    "remove card": "Wyjmij kartę",
    "remove company card": "Usunąć kartę firmową?",
    "remove company card description": "Czy na pewno chcesz usunąć kartę firmową „{{cardName}}”? Tego działania nie można cofnąć.",
    "status": "Status",
    "update version warning": "Dostępna jest nowsza wersja.  Zalecamy aktualizację, aby uzyskać najlepszą wydajność.",
    "valid until": "Ważne do",
    "version details after connection is established": "Szczegóły dotyczące wersji pojawią się tutaj po pierwszym połączeniu z kartą firmową."
  },
  "Cookies": {
    "accept": "Akceptuj",
    "always active": "Zawsze aktywny",
    "analytics cookies": "Analityczne pliki cookie",
    "analytics cookies description": "Te pliki służą do analizy i pomagają gromadzić dane, które pozwalają nam zrozumieć, w jaki sposób użytkownicy korzystają z naszych stron internetowych. Dzięki tym informacjom możemy zarówno ulepszać treści, jak i tworzyć lepsze funkcje, które poprawiają komfort użytkowania. Tę kategorię plików cookie można wyłączyć.",
    "cookie banner message": "My oraz wybrane podmioty zewnętrzne wykorzystujemy pliki cookie lub podobne technologie do celów technicznych oraz, za Państwa zgodą, do innych celów określonych w <1>polityce plików cookie</1>.",
    "cookie modal title": "Używamy plików cookie",
    "cookie policy": "polityka plików cookie",
    "essential cookies": "Niezbędne pliki cookie",
    "essential cookies description": "Te pliki są wykorzystywane do działań, które są absolutnie niezbędne do działania lub świadczenia usługi, o którą nas poprosiłeś, pliki te nie gromadzą informacji o Tobie, które mogłyby zostać wykorzystane do celów marketingowych, i nie zapamiętują, gdzie byłeś w Internecie. Tę kategorię plików cookie nie można wyłączyć.",
    "text": "Ta strona internetowa przechowuje dane, takie jak pliki cookie, aby umożliwić działanie niezbędnych funkcji serwisu, w tym analityki."
  },
  "Dashboard": {
    "added": "Dodano",
    "Available": "Dostępne",
    "cards": "Karty",
    "card tooltips": {
      "connectivity": "<strong>Online:</strong>\nUrządzenie połączyło się w ciągu ostatnich 24 godzin\n\n<strong>Offline:</strong>\nUrządzenie nie połączyło się w ciągu ostatnich 24 godzin\n\n<strong>Nieaktywne:</strong>\nUrządzenie nigdy nie nawiązało pomyślnego połączenia z TachoSync",
      "driver downloads": "<strong>Na czas:</strong>\n0–14 dni od ostatniego pobrania\n\n<strong>Wkrótce:</strong>\n15–28 dni od ostatniego pobrania\n\n<strong>Przeterminowane:</strong>\n29+ dni od ostatniego pobrania\n\n<strong>Brak pobrań:</strong>\nNie odnotowano jeszcze żadnych pobrań",
      "vehicle downloads": "<strong>Na czas:</strong>\n0–60 dni od ostatniego pobrania\n\n<strong>Wkrótce:</strong>\n61–90 dni od ostatniego pobrania\n\n<strong>Przeterminowane:</strong>\n91+ dni od ostatniego pobrania\n\n<strong>Brak pobrań:</strong>\nNie odnotowano jeszcze żadnych pobrań"
    },
    "cc expiry": {
      "expired": "Wygasło",
      "near expiry": "Zbliża się termin ważności",
      "near expiry tooltip": "Wygasające w ciągu 3 miesięcy",
      "upcoming expiry": "Zbliżający się termin ważności",
      "upcoming expiry tooltip": "Wygasające w ciągu 3–6 miesięcy"
    },
    "company cards": "Karty firmowe",
    "company cards expiration": "Wygasanie kart firmowych",
    "connectivity": "Łączność",
    "connectivity tabs": {
      "company cards": "Karty firmowe",
      "devices": "Urządzenia"
    },
    "credit overdraft activated": "Aktywowano kredyt w rachunku bieżącym: {{overDraftAmount}} kredytów",
    "credits": "Kredyty",
    "credits health": {
      "Healthy": "W dobrym stanie",
      "InOverdraft": "W ramach kredytu w rachunku bieżącym",
      "LimitReached": "Osiągnięto limit",
      "LowCredits": "Niski stan środków",
      "OverdraftLimitReached": "Osiągnięto limit"
    },
    "credits history": "Historia kredytów",
    "credits history actions": {
      "BonusCredits": "Punkty bonusowe",
      "CreditsExpiration": "Wygasanie kredytów",
      "Deduction": "Miesięczna potrącenie",
      "FreeTrial": "Dodano kredyty demonstracyjne",
      "MonthlyDeduction": "Miesięczna potrącenie",
      "Purchase": "Dodano środki",
      "WebTachoLicenseConversion": "Migracja"
    },
    "credits statuses": {
      "available": "Dostępne",
      "balance": "Saldo",
      "overdraft": "Kredyt w rachunku bieżącym",
      "remaining overdraft": "Pozostałe saldo debetowe",
      "reserved": "Zastrzeżone"
    },
    "Deactivated": "Wyłączone",
    "deducted": "Odliczone",
    "demo credits": {
      "demo": "Wersja demonstracyjna",
      "demo credits expired tooltip": "Kredyty demo wygasły. Aby kontynuować korzystanie z TachoSync, należy zakupić kredyty.",
      "demo credits used up tooltip": "Wszystkie kredyty demonstracyjne zostały wykorzystane. Aby kontynuować korzystanie z TachoSync, należy dokonać zakupu kredytów.",
      "demo info tooltip": "Kredyty demo są aktywowane przy pierwszym połączeniu IMEI i pozostają aktywne przez 90 dni."
    },
    "device status": "Stan urządzenia",
    "devices": "Urządzenia",
    "driver data": "Dane kierowców",
    "driver downloads": "Pobrane dane kierowców",
    "DueSoon": "Wkrótce",
    "estimated": "Szacunkowe",
    "expires": "Wygasają",
    "how credits work": {
      "bottom content": {
        "header": "Kiedy rezerwowany jest kredyt?",
        "table": {
          "body": {
            "any": "Dowolne",
            "any behaviour": "Brak nowego kredytu. Istniejąca rezerwacja pozostaje ważna do końca miesiąca.",
            "newly assigned": "Nowo przypisane",
            "newly assigned behaviour": "Zastrzeżone przy połączeniu. Przeniesione do VIN po pierwszym pobraniu.",
            "replaced vin known": "Wymieniony (znany numer VIN)",
            "replaced vin known behaviour": "Brak nowego kredytu. Dotychczasowa rezerwacja pozostaje w mocy.",
            "none": "Brak",
            "none behaviour": "Nie zarezerwowano limitu. Pobieranie rozpocznie się dopiero po przypisaniu urządzenia."
          },
          "head": {
            "credit behaviour": "Zachowania kredytowe",
            "device": "Urządzenie",
            "vehicle status": "Stan pojazdu"
          }
        }
      },
      "button tooltip": "Zobacz, jak działają kredyty",
      "main description": "Kredyty TachoSync są ważne przez 12 miesięcy. Każdy nowy zakup przedłuża termin ważności o kolejne 12 miesięcy, dzięki czemu kredyty pozostają dostępne tak długo, jak długo użytkownik jest aktywny.",
      "main title": "Jak działają kredyty",
      "middle content": {
        "description": "Wykorzystanie kredytów w Twojej flocie odzwierciedla dokładnie liczbę aktywnych pojazdów na podstawie unikalnego numeru VIN. Urządzenia można wymieniać, przenosić między pojazdami lub przypisywac na nowo w ramach spółek zależnych bez zużywania dodatkowych kredytów, o ile tożsamość pojazdu została już ustalona.",
        "header": "Limity są przypisane do każdego aktywnego pojazdu, a nie do każdego urządzenia.",
        "read more on wiki": "Więcej informacji na Wiki"
      },
      "top content": {
        "active vehicle": "Aktywny pojazd",
        "device can change freely": "Urządzenie można dowolnie zmieniać",
        "equals one credit": "= 1 punkt",
        "identified by IMEI": "Identyfikacja na podstawie numeru IMEI",
        "identified by VIN": "Identyfikacja na podstawie numeru VIN",
        "tracking device": "Urządzenie śledzące"
      }
    },
    "Inactive": "Nieaktywne",
    "last 12 months": "Ostatnie 12 miesięcy",
    "news": "Aktualności",
    "no history to show": "Brak historii do wyświetlenia",
    "no news": "Brak aktualności",
    "no results": "Brak wyników",
    "NoDownloads": "Brak pobrań",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Na czas",
    "Overdue": "Przeterminowane",
    "Remaining": "Pozostałe",
    "Reserved": "zarezerwowane",
    "response error": "Wystąpił błąd. Spróbuj odświeżyć stronę",
    "timeline": "Oś czasu",
    "tooltip": {
      "click to expand": "Kliknij, aby rozwinąć",
      "connected card expire soon": "Karta wkrótce straci ważność: {{expirationDate}}",
      "disconnected card": "Karta firmowa została odłączona.\nOstatnio widziano: {{lastSeen}}.",
      "disconnected card expire soon": "Karta firmowa została odłączona.\nOstatnia aktywność: {{lastSeen}}. \n \n Karta wkrótce straci ważność: {{expirationDate}}.",
      "expired card": "Karta straciła ważność w dniu {{expirationDate}}.\nWymień kartę firmową na ważną.",
      "offline card": "Karta firmowa jest w offline.\nOstatnio widziano: {{lastSeen}}.",
      "take me there": "Przejdź tam"
    },
    "Upcoming charge": "Nadchodząca opłata",
    "vehicle data": "Dane pojazdu",
    "vehicle downloads": "Pobrane dane pojazdów",
    "view history": "Wyświetl historię"
  },
  "Date picker": {
    "disableFuture": "Data wyłączenia",
    "disablePast": "Data wyłączenia",
    "invalid date format": "Nieprawidłowy format daty",
    "invalidDate": "Nieprawidłowa data",
    "maxDate": "Nieprawidłowa data",
    "minDate": "Nieprawidłowa data",
    "shouldDisableDate": "Data wyłączenia"
  },
  "Details": {
    "activities": "aktywności",
    "add new email recipient": {
      "choose a file format": "Wybierz format pliku",
      "enter email": "Wpisz adres e-mail",
      "title": "Dodaj nowego odbiorcę"
    },
    "api company id": "identyfikator firmy API",
    "autoAssignGlobalScheduleToDriver": "Przypisz globalny harmonogram do nowych kierowców",
    "autoAssignGlobalScheduleToVehicle": "Przypisz globalny harmonogram do nowych pojazdów",
    "automaticDriverRegistrationEnabled": "Automatyczna rejestracja nowych kierowców",
    "card holder": "Imię i nazwisko posiadacza karty",
    "client code": "Kod klienta",
    "close details": "Zamknij szczegóły",
    "company": "Firma",
    "company cards": "Karty firmowe",
    "company cards limit reached": "Osiągnięto maksymalną liczbę kart firmowych dla tej firmy, {{currCount}}/{{maxCount}}.",
    "company settings": "Ustawienia firmy",
    "Completed": "Zakończone",
    "connection settings": "Ustawienia połączenia",
    "creator": "Twórca",
    "credits": "kredyty",
    "credits overdraft tooltip": "Zaktualizowano logikę rezerwacji miesięcznego limitu kredytowego, aby umożliwić ujemne saldo na koncie. Pomoże to w płynniejszym przejściu z Web Tacho bez presji związanej z koniecznością natychmiastowego dokonywania zakupów na kredyt.",
    "current status": "Aktualny stan",
    "Daily": "Codziennie",
    "data types": "Typy danych",
    "deactivated": "Wyłączone",
    "deactivated vehicle banner": {
      "description": "Ten pojazd nie będzie rezerwował nowych kredytów, a pliki pojazdu nie będą mogły zostać pobrane, dopóki nie zostanie aktywowany.",
      "link": "Aktywuj pojazd",
      "title": "Pojazd jest wyłączony"
    },
    "detailed speed": "Szczegółowa prędkość",
    "details": "Szczegóły",
    "device imei": "IMEI",
    "device status": "Stan urządzenia",
    "download status": "Stan pobierania",
    "download time": "Czas pobierania",
    "DownloadPending": "Pobieranie w toku",
    "driver": "Kierowca",
    "driver id": "Identyfikator kierowcy",
    "driver status": "Status kierowcy",
    "drivers": "Kierowcy",
    "edit": "Edytuj",
    "edit user": "Edytuj {{userEmail}}",
    "email limit reached": "Osiągnąłeś maksymalną liczbę wiadomości e-mail dla tej firmy.",
    "email transfer": "E-mail transfer",
    "email transfer info tooltip": "Funkcja e-mail transfer umożliwia otrzymywanie pobranych danych z tachografu za pośrednictwem poczty e-mail. Po zakończeniu harmonogramu system automatycznie prześle wiadomość e-mail do skonfigurowanych odbiorców. Każda firma może dodać maksymalnie {{maxCount}} odbiorców wiadomości e-mail.",
    "endpointUrl": "Adres URL punktu końcowego",
    "events and faults": "Zdarzenia i usterki",
    "Every  days": "Co {{count}} dni",
    "Every month": "Co miesiąc",
    "EveryDays": "Co {{count}} dni",
    "Feature not available in BETA version": "Funkcja niedostępna w wersji BETA",
    "file format": "Format pliku",
    "file sync": "Synchronizacja plików",
    "general": "Ogólne",
    "host": "Host",
    "imei": "IMEI",
    "included": "W zestawie",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Ostatnia aktywność",
    "last download attempt": "Ostatnia próba pobrania",
    "last successful download": "Ostatnie pomyślne pobranie",
    "Never": "Nigdy",
    "next download": "Pobierz dalej",
    "next download attempt": "Kolejna próba pobrania",
    "Next download attempt in  day": "Kolejna próba pobrania za {{count}} dni",
    "Next download attempt in  days": "Kolejna próba pobrania za {{count}} dni",
    "no company cards": "Nie dodano żadnych kart firmowych.",
    "no driver schedule": "Kierowca nie ma przypisanych harmonogramów.",
    "no recipients added": "Nie dodano żadnych odbiorców",
    "no vehicle schedule": "Do pojazdu nie przypisano żadnych harmonogramów.",
    "not included": "Nie obejmuje",
    "on next connection": "Przy następnym połączeniu",
    "open files": "Otwórz pliki",
    "open files disabled tooltip": "Dla tego obiektu nie ma dostępnych plików.",
    "other": "Inne",
    "overview": "Przegląd",
    "parent company": "Firma macierzysta",
    "password": "Hasło",
    "port": "Port",
    "Quick schedule was completed": "Szybki harmonogram został ukończony",
    "remotePath": "Ścieżka do katalogu zdalnego",
    "remove": "Usuń",
    "remove email recipient": {
      "description": "Czy na pewno chcesz usunąć tego odbiorcę wiadomości e-mail? Tego działania nie można cofnąć.",
      "title": "Usunąć {{userEmail}}?"
    },
    "remove schedule": "Usuń harmonogram",
    "reserved": "Zarezerwowane",
    "schedule details": "Szczegóły harmonogramu",
    "schedule history": "Historia harmonogramów",
    "schedule start time": "Godzina rozpoczęcia harmonogramu",
    "schedules": "Harmonogramy",
    "show less": "Pokaż mniej",
    "show more": "Pokaż więcej",
    "show older": "Pokaż starsze",
    "status": "Status",
    "sub companies": "Firmy zależne",
    "technical data": "Dane techniczne",
    "Upon device connection": "Połączenie z urządzeniem",
    "username": "Nazwa użytkownika",
    "users": "Użytkownicy",
    "vehicles": "Pojazdy",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "Oczekiwanie na połączenie z urządzeniem",
    "WaitingForScheduleStartTime": "Oczekiwanie na rozpoczęcie zgodne z harmonogramem"
  },
  "Dialog": {
    "account id": "ID konta",
    "account id cannot contain more than": "Identyfikator konta nie może zawierać więcej niż {{maxNumber}} znaków",
    "activate vehicles": {
      "description": "Po aktywacji pojazdy mogą rezerwować środki w oparciu o unikalny miesięczny limit połączeń. Czy na pewno chcesz aktywować następującą liczbę pojazdów?",
      "title": "Aktywować pojazdy?"
    },
    "add": "Dodaj",
    "add company card": "Dodaj nową kartę firmową",
    "add driver": "Dodaj kierowcę",
    "add integration": "Dodaj integrację",
    "add new integration": {
      "description": "Wybierz typ integracji, którą chcesz dodać, a następnie skonfiguruj szczegóły w kolejnym kroku.",
      "title": "Dodaj nową integrację"
    },
    "add vehicle": "Dodaj pojazd",
    "add vehicle description": "Dodaj pojazd, manualnie wprowadzając wszystkie dane rejestracyjne.",
    "add vehicle imei in use accessible": {
      "description": "Ten numer IMEI jest już powiązany z innym pojazdem. Ponowne przypisanie spowoduje odłączenie tego pojazdu od pobierania plików. Czy na pewno chcesz kontynuować?",
      "title": "IMEI już w użyciu",
      "vehicle imei": "Pojazd o numerze IMEI „{{imeiValue}}”:"
    },
    "all resource": "Wszystkie {{resource}}",
    "api key": "Klucz API",
    "api key placeholder": "Wprowadź klucz API",
    "api key cannot contain more than": "Klucz API nie może zawierać więcej niż {{maxNumber}} znaków",
    "api key edit": {
      "dialog title": "Edytuj klucz API \"{{keyName}}\"",
      "success banner": "Klucz API został pomyślnie zmieniony."
    },
    "api key name": "Nazwa klucza",
    "api key name required": "Nazwa klucza nie może być pusta",
    "api key name too long": "Nazwa klucza nie może zawierać więcej niż {{maxNumber}} znaków",
    "api management": {
      "description": "Utwórz swój klucz API, aby bezpiecznie zarządzać dostępem API do naszego systemu, umożliwiając płynną integrację z własnym oprogramowaniem i procesami roboczymi. Dokumentację API TachoSync można znaleźć tutaj.",
      "generated api key": "Wygenerowany klucz API",
      "success banner": "Klucz API został pomyślnie utworzony. Proszę zapisać poniższe informacje, ponieważ nie będzie można ich ponownie wyświetlić."
    },
    "cancel invitation": "Anuluj zaproszenie",
    "cancel invitation description": "Czy na pewno chcesz anulować zaproszenie dla {{userEmail}}?",
    "card holder name": "Imię i nazwisko posiadacza karty",
    "card holder name not valid": "Nazwisko posiadacza karty nie może zawierać więcej niż {{maxNumber}} znaków",
    "card holder name should not be empty": "Pole „Nazwisko posiadacza karty” nie może być puste",
    "card holder name too short": "Nazwisko posiadacza karty musi zawierać co najmniej {{minNumber}} znaków",
    "card id not valid": "Numer identyfikacyjny karty nie może zawierać więcej niż {{maxNumber}} znaków",
    "card id should contain only digits, letters and hyphens": "Identyfikator karty powinien zawierać wyłącznie cyfry (0–9), litery A–F oraz myślniki (-).",
    "card id should contain only numbers": "Identyfikator karty powinien zawierać wyłącznie cyfry",
    "card id should not be empty": "Numer identyfikacyjny karty nie może być pusty",
    "card id too short": "Numer identyfikacyjny karty musi zawierać co najmniej {{minNumber}} znaków",
    "card name": "Nazwa karty",
    "card name not valid": "Nazwa karty nie może zawierać więcej niż {{maxNumber}} znaków",
    "card name should not be empty": "Nazwa karty nie może być pusta",
    "card name too short": "Nazwa karty musi zawierać co najmniej {{minNumber}} znaków",
    "choose period": "Wybierz okres",
    "client company": "Firma klienta",
    "company": "Firma",
    "company card id": "Identyfikator karty firmowej",
    "company name": "Nazwa firmy",
    "company name in tachoSync": "Nazwa firmy w TachoSync",
    "company name placeholder": "Np.: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Zezwól na przekroczenie limitu kredytów",
      "auto add new drivers": "Automatyczna rejestracja nowych kierowców",
      "auto add new drivers tooltip": "Gdy tylko zostanie rozpoznany nowy identyfikator kierowcy, TachoSync automatycznie doda go do tabeli kierowców.",
      "auto assign global schedule to drivers": "Automatyczne przypisywanie globalnego harmonogramu do nowych kierowców",
      "auto assign global schedule to drivers tooltip": "Automatycznie stosuje globalny harmonogram pobierania danych w odniesieniu do nowo zarejestrowanych kierowców, zapewniając pobieranie danych bez konieczności manualnej interwencji.",
      "auto assign global schedule to vehicles": "Automatyczne przypisywanie globalnego harmonogramu do nowych pojazdów",
      "auto assign global schedule to vehicles tooltip": "Automatycznie stosuje globalny harmonogram pobierania danych do nowo zarejestrowanych pojazdów, zapewniając pobieranie danych bez konieczności manualnej interwencji.",
      "auto download driver data": "Automatyczne pobieranie danych kierowcy przy pierwszym połączeniu",
      "auto download driver data tooltip": "Dane z karty kierowcy są pobierane automatycznie przy pierwszym połączeniu kierowcy. Dzięki temu przed ustaleniem harmonogramów można zebrać pełną historię nowych kierowców.",
      "auto update vehicle registration number": "Automatyczna aktualizacja numeru rejestracyjnego pojazdu (VRN)",
      "auto update vehicle registration number tooltip": "Po włączeniu tej opcji numer rejestracyjny (VRN) wprowadzony podczas tworzenia pojazdu zostanie nadpisany wartością odczytaną z danych tachografu po pierwszym pomyślnym pobraniu.",
      "automatic initial vehicle download": "Automatyczne pobieranie danych pojazdu przy pierwszym połączeniu",
      "automatic initial vehicle download tooltip": "Dane pojazdu są pobierane automatycznie przy pierwszym podłączeniu pojazdu. Dzięki temu przed skonfigurowaniem harmonogramów rejestrowana jest pełna historia nowych pojazdów.",
      "title": "Ustawienia firmy"
    },
    "confirm add schedule": "Dodaj harmonogram?",
    "confirm deactivate api key": {
      "description": "Czy na pewno chcesz dezaktywować klucz API „{{apiKeyName}}”?",
      "title": "Czy chcesz dezaktywować klucz API?"
    },
    "confirm deactivate integration": {
      "description": "Czy na pewno chcesz wyłączyć integrację „{{integrationName}}”?",
      "title": "Wyłączyć integrację?"
    },
    "confirm delete analysis providers": "Czy na pewno chcesz usunąć następującą liczbę dostawców analiz? Tego działania nie można cofnąć.",
    "confirm delete api credentials": "Czy na pewno chcesz usunąć wybrane poświadczenia API? Tego działania nie można cofnąć, a wszelkie wywołania API wykonane przy użyciu tych poświadczeń zostaną natychmiast odrzucone.",
    "confirm delete companies": "Czy na pewno chcesz usunąć wybraną firmę? Tego działania nie można cofnąć.",
    "confirm delete drivers": "Czy na pewno chcesz usunąć następującą liczbę kierowców?",
    "confirm delete integrations": "Czy na pewno chcesz usunąć następującą liczbę integracji? Tego działania nie można cofnąć.",
    "confirm delete users": "Czy na pewno chcesz usunąć następującą liczbę użytkowników? Tego działania nie można cofnąć.",
    "confirm delete vehicles": "Czy na pewno chcesz usunąć następującą liczbę pojazdów?",
    "confirm empty imei": {
      "description": "Nie wypełniłeś pola IMEI. Pojazdy bez numeru IMEI nie mogą połączyć się z TachoSync i nie są w stanie pobrać plików.\nCzy na pewno chcesz kontynuować?",
      "title": "Nie dodano numeru IMEI"
    },
    "convey integration": {
      "add": {
        "description": "Skonfiguruj połączenie z Convey",
        "title": "Dodaj integrację z Convey"
      },
      "edit": {
        "description": "Skonfiguruj połączenie z Convey",
        "title": "Edytuj integrację z Convey"
      },
      "provider settings description": "Należy pamiętać o użyciu danych uwierzytelniających dostarczonych przez Convey.",
      "provider settings title": "Ustawienia dostawcy"
    },
    "create": "Utwórz",
    "create company": "Załóż firmę",
    "create company main description": "Wybierz opcję utworzenia nowej firmy zależnej w tej hierarchii lub utwórz nowego klienta przy użyciu kodu LZ klienta.",
    "create new hierarchy": "Utwórz nową hierarchię",
    "create news": "Utwórz wiadomość",
    "create news description": "Krótko przedstaw treść modalu.",
    "create quick schedule": "Szybkie tworzenie harmonogramu",
    "create schedule": "Utwórz harmonogram",
    "create schedule description": "Skonfiguruj automatyczne pobieranie plików, wybierając datę, godzinę i częstotliwość. System zajmie się pobieraniem za Ciebie, zapewniając zgodność z przepisami i dokładność danych bez konieczności manualnej obsługi. Nie można ustawić godziny rozpoczęcia w przeszłości.",
    "credits history": {
      "description": "Śledź aktualne saldo kredytów przeglądaj dane historyczne.",
      "description generate report": "Śledź aktualne saldo kredytów, przeglądaj dane historyczne i generuj raport w formacie „.csv” zawierający wszystkie kredyty wykorzystane w ciągu ostatnich 12 miesięcy.",
      "generate report description": "Wybierz dowolny okres z ostatnich 12 miesięcy i wygeneruj raport dotyczący wykorzystanych kredytów.",
      "generate report title": "Generuj raport",
      "title": "Historia kredytów"
    },
    "custom period": "Okres niestandardowy",
    "date display format": "Format wyświetlania daty",
    "date range": "Zakres dat",
    "deactivate vehicle": "Dezaktywuj ten pojazd",
    "deactivate vehicle description": "Pojazdy wyłączone nie będą rezerwować nowych kredytów i nie będą mogły pobierać danych",
    "deactivate vehicles": {
      "description": "Pojazdy z wyłączonymi kontami nie będą rezerwować nowych kredytów i nie będą mogły pobierać danych.",
      "title": "Czy wyłączyć pojazdy?"
    },
    "delete": "Usuń",
    "delete analysis providers": "Usunąć dostawców usług analitycznych?",
    "delete api credentials": "Usuń dane uwierzytelniające API?",
    "delete companies": "Usunąć firmy?",
    "delete companies warning": "Usunięcie firm spowoduje usunięcie wszystkich zasobów należących do tych firm.",
    "delete drivers": "Usunąć kierowców?",
    "delete integrations": "Usunąć integrację?",
    "delete news": "Usunąć wiadomości?",
    "delete news description": "Czy na pewno chcesz usunąć wybrane wiadomości?",
    "delete unpublished release notes": "Usuń niepublikowane informacje o wydaniu?",
    "delete unpublished release notes description": "Czy na pewno chcesz usunąć niepublikowane informacje o wydaniu?",
    "delete users": "Usunąć użytkowników?",
    "delete vehicles": "Usunąć pojazdy?",
    "description": "Opis (opcjonalnie)",
    "description not valid": "Opis nie może zawierać więcej niż {{maxNumber}} znaków",
    "description required": "Opis",
    "description should not be empty": "Opis nie może być pusty",
    "device imei": "Numer IMEI urządzenia",
    "dialog description": {
      "create company description": "Maksymalna dopuszczalna liczba poziomów w drzewie struktury firmy wynosi {{maxNumber}}.",
      "create new hierarchy description": "Maksymalna dopuszczalna liczba poziomów w drzewie struktury firmy wynosi {{maxNumber}}. Wybierz opcję utworzenia nowej firmy zależnej w ramach tej hierarchii lub utwórz nowego klienta, używając kodu LZ klienta."
    },
    "download activities": "Czynności związane z pobieraniem",
    "download blocked message": "Pobieranie zablokowane - skontaktuj się z dostawcą, aby rozwiązać ten problem.",
    "download data types": "Typy danych do pobrania",
    "download drivers files": "Pobierz pliki sterowników",
    "download history dialog title": "Historia pojazdu o numerze {{vehicleNumber}}",
    "download monitoring dialog tooltip": "Wszystkie dane w tym widoku są automatycznie odświeżane co <strong>10 sekund</strong>.\nStan urządzenia odzwierciedla ostatnie połączenie, a nie aktualny stan pojazdu.",
    "download only selection": "Pobrane zostaną tylko wybrane pliki.",
    "download sample file message": "Pobierz <1>przykładowy szablon</1> CSV, aby zapoznać się z wymaganym formatem.",
    "download status banners": {
      "CompanyCardExpired": "Karta firmowa straciła ważność. Proszę dodać ważną kartę firmową.",
      "InsufficientCredits": "Niewystarczająca ilość kredytów. Proszę doładować konto, aby pobrać pliki.",
      "NoCompanyCards": "Aby rozpocząć pobieranie, karta firmowa musi być podłączona do Internetu. W tej chwili nie ma żadnych dostępnych plików.",
      "NoSchedulesApplied": "Ten pojazd nie ma przypisanych harmonogramów",
      "VehicleDeactivated": "Ten pojazd jest dezaktywowany i nie może rozpocząć procesu pobierania"
    },
    "download status dialog title": "Monitorowanie pobierania danych z {{vehicleNumber}}",
    "download vehicles files": "Pobieranie plików dotyczących pojazdów",
    "driver file destination": "Miejsce docelowe plików kierowców",
    "driver file destination tooltip": "Wybierz, czy pliki kierowców będą zapisywane w folderze pojazdu, z którego zostały pobrane, czy w dedykowanych folderach kierowców według identyfikatora kierowcy.",
    "driver folder": "Folder kierowcy",
    "driver id": "Identyfikator kierowcy",
    "driver id not valid": "Identyfikator kierowcy powinien zawierać {{maxNumber}} znaków alfanumerycznych",
    "driver id placeholder": "Np.: 360896050032309",
    "driver id should not be empty": "Pole „ID kierowcy” nie może być puste",
    "driver name": "Imię i nazwisko kierowcy",
    "drivers folder naming": "Nazwa folderu kierowców",
    "edit company": "Edytuj firmę „{{name}}”",
    "edit driver": "Edytuj kierowcę „{{name}}”",
    "edit news": "Edytuj wiadomość",
    "edit release notes tooltip": "Te wiadomości zostały utworzone jako informacje o wydaniu i nie można ich zmieniać.",
    "edit user": "Edytuj użytkownika",
    "edit vehicle": "Edytuj pojazd „{{name}}”",
    "edit vehicle imei in use accessible": {
      "description": "Ten numer IMEI jest już przypisany do innego pojazdu. Możesz wybrać opcję zamiany numerów IMEI między tymi dwoma pojazdami lub nadpisania numeru IMEI.",
      "title": "IMEI już w użyciu"
    },
    "email": "E-mail",
    "endpointUrl": "Adres URL punktu końcowego",
    "endpoint url": "Adres URL punktu końcowego",
    "endpoint url not valid": "Adres URL punktu końcowego jest nieprawidłowy",
    "endpoint url placeholder": "Wprowadź adres URL",
    "enter": "Wprowadź",
    "enter company card id": "Wprowadź identyfikator karty firmowej znajdujący się w aplikacji Company Card Authenticator.",
    "enter here": "Wpisz tutaj",
    "enter name": "Wpisz nazwę",
    "enter password": "Wprowadź hasło",
    "enter username": "Wprowadź nazwę użytkownika",
    "expiration date optional": "Data ważności (opcjonalnie)",
    "export drivers": {
      "description": "Wyeksportuj wszystkich kierowców z wybranej firmy do plików .csv.",
      "include drivers from all companies": "Uwzględnij kierowców ze wszystkich firm",
      "title": "Eksport kierowców"
    },
    "export vehicles": {
      "description": "Wyeksportuj wszystkie pojazdy z wybranej firmy do plików w formacie .csv.",
      "include vehicles from all companies": "Uwzględnij pojazdy wszystkich firm",
      "title": "Eksport pojazdów"
    },
    "feature switches": {
      "feature switches": "Przełączniki funkcji",
      "toggle integrations page": "Włącz stronę integracji"
    },
    "field cannot be changed": "Tego pola nie można zmienić",
    "field cannot be empty": "Pole {{fieldName}} nie może być puste",
    "field length not valid": "To pole nie może zawierać więcej niż {{maxNumber}} znaków",
    "file format": "Format pliku",
    "filtered resource": "Filtrowane {{resource}}",
    "filtered drivers": "Przefiltrowani kierowcy",
    "filtered vehicles": "Pojazdy z filtrami",
    "from": "Od",
    "future dates": {
      "1 day": "za 1 dzień",
      "1 minute": "za 1 minutę",
      "1 month": "za 1 miesiąc",
      "1 week": "za 1 tydzień",
      "1 year": "za 1 rok",
      "hours and minutes": "za {{hourCount}} godz. {{minutesCount}} min",
      "less than a minute": "w <1 minutę",
      "multiple days": "za {{daysCount}} dni",
      "multiple minutes": "za {{minutesCount}} minut",
      "multiple months": "za {{monthsCount}} miesięcy",
      "multiple weeks": "za {{weeksCount}} tygodni",
      "multiple years": "za {{yearsCount}} lat"
    },
    "generate api key": {
      "title": "Wygeneruj klucz API"
    },
    "host": "Host",
    "host cannot contain more than": "Nazwa hosta nie może zawierać więcej niż {{maxNumber}} znaków",
    "imei": "IMEI",
    "imei not valid": "Numer IMEI powinien zawierać {{maxNumber}} znaków numerycznych",
    "imei placeholder": "Np.: 360896050032309",
    "imei should not be empty": "Pole IMEI nie może być puste",
    "import drivers": "Import kierowców",
    "import drivers description": "Dodaj kierowców do listy, importując ich z pliku.",
    "import vehicles": "Import pojazdów",
    "import vehicles description": "Dodaj pojazdy do swojej listy, importując je z pliku.",
    "integration name": "Nazwa integracji",
    "integration type": "Rodzaj integracji",
    "integrations": {
      "deactivate api key": "Dezaktywuj klucz API",
      "deactivate sftp": "Wyłącz SFTP",
      "deactivate integration tooltip": "Tymczasowo wyłącz integrację. Możesz ją ponownie włączyć, odznaczając tę opcję.",
      "deactivate integration": {
        "title": "Wyłącz tę integrację",
        "tooltip": "Tymczasowo wyłącz integrację. Możesz ją ponownie włączyć, odznaczając tę opcję."
      },
      "disable integration": {
        "description": "Czy na pewno chcesz wyłączyć integrację „{{integrationName}}”?",
        "title": "Wyłączyć integrację?"
      },
      "driver files info banner": "Należy pamiętać, że pliki kierowców pobrane przed {{formattedDate}} zostaną umieszczone w folderze ostatniego pojazdu, którym kierował dany kierowca. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Upewnij się, że nazwa użytkownika i hasło zostały wprowadzone poprawnie.\nIntegracja zostanie zapisana ze statusem „Nieudana” do momentu wprowadzenia poprawnych danych logowania.",
          "title": "Nieprawidłowe dane logowania."
        },
        "FolderCreationFailed": {
          "description": "Aplikacja TachoSync połączyła się z serwerem, ale nie ma uprawnień do tworzenia folderów ani przesyłania plików do ścieżki docelowej.\nIntegracja zostanie zapisana ze statusem „Nieudana” do momentu rozwiązania problemu i ponownej próby połączenia.",
          "title": "Brak uprawnień do zapisu."
        },
        "HostUnreachable": {
          "description": "Upewnij się, że adres serwera i port są poprawne, a serwer jest dostępny online.\nIntegracja zostanie zapisana ze statusem „Nieudana” do momentu rozwiązania problemu i ponownej próby połączenia.",
          "title": "Nie można połączyć się z serwerem."
        },
        "PathNotFound": {
          "description": "Nie można znaleźć wskazanego katalogu na serwerze. Sprawdź, czy ścieżka jest poprawna.\nIntegracja zostanie zapisana ze statusem „Niepowodzenie” do momentu podania prawidłowej ścieżki.",
          "title": "Nie znaleziono ścieżki."
        },
        "PermissionDenied": {
          "description": "Upewnij się, że aplikacja TachoSync posiada niezbędne uprawnienia dostępu do tej ścieżki.\nIntegracja zostanie zapisana ze statusem „Nieudana” do momentu zaktualizowania uprawnień i ponownej próby połączenia.",
          "title": "Odmowa dostępu do ścieżki."
        },
        "Unknown": {
          "description": "Podczas próby połączenia się z serwerem SFTP wystąpił nieoczekiwany błąd. Sprawdź dane i ustawienia serwera.\nIntegracja zostanie zapisana ze statusem „Nieudana” do momentu rozwiązania problemu i ponownej próby połączenia.",
          "title": "Wystąpił nieoczekiwany błąd."
        }
      },
      "include files from all sub companies": "Uwzględnij pliki ze wszystkich firm zależnych",
      "include files tooltip": "Po wybraniu tej integracji będą również pobierane pliki ze wszystkich spółek zależnych na Twoim koncie",
      "include historical files": "Uwzględnij pliki historyczne",
      "include historical files tooltip": "Po zaznaczeniu tej opcji zostaną pobrane również pliki pobrane przed utworzeniem tej integracji.",
      "select driver files destination": "Wybierz miejsce docelowe plików kierowców"
    },
    "introduce name": "Wprowadź nazwę",
    "invite user": "Zaproś użytkownika",
    "invite user description": "Po wysłaniu zaproszenia użytkownik otrzyma \nwiadomość e-mail z linkiem do utworzenia konta. Link będzie ważny przez 7 dni.",
    "invite user sent": "Zaproszenie użytkownika zostało pomyślnie wysłane.",
    "loading": "Ładowanie...",
    "make release notes": "Utwórz informacje o wydaniu",
    "make release notes info": "Jeśli to pole zostanie zaznaczone, wiadomość zostanie opublikowana w sekcji Informacje o wydaniu, a jej tytuł zostanie zmieniony na Informacje o wydaniu.",
    "max download files": "Maksymalna liczba plików na jedno pobranie - {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Czy na pewno?",
        "description": "Zamierzasz przenieść „{{sourceCompany}}” do „{{targetCompany}}”. Ta operacja jest nieodwracalna. Czy na pewno chcesz kontynuować?"
      },
      "description": "Wybierz firmę źródłową oraz firmę docelową, do której chcesz ją przenieść. Firma źródłowa wraz z jej zasobami zostanie umieszczona w wybranej firmie docelowej. Czynność ta jest nieodwracalna.",
      "error dialog": {
        "description": "Maksymalna dozwolona liczba poziomów firmy wynosi 4. Przeniesienie wybranej firmy w to miejsce spowodowałoby przekroczenie tego limitu.",
        "title": "Nie można przenieść firmy"
      },
      "info banner": "Firma źródłowa zachowa wszystkie swoje pojazdy, kierowców, pliki, firmy, użytkowników, integracje oraz niestandardowe harmonogramy. Jeśli na poziomie firmy nadrzędnej włączono harmonogram globalny, zostanie on odziedziczony po przeniesieniu. W przeciwnym razie istniejące harmonogramy zostaną zachowane bez zmian.",
      "source company": "Firma źródłowa",
      "sftp warning": "Wybrana firma posiada skonfigurowany i działający serwer SFTP. Połączenie SFTP zostanie przerwane na czas przenoszenia firmy. Po zakończeniu przenoszenia zostanie utworzona nowa ścieżka SFTP, a połączenie zostanie wznowione.",
      "target company": "Firma docelowa",
      "title": "Przeniesienie firmy"
    },
    "move vehicles": "Przemieszczanie pojazdów",
    "move vehicles info": "Uwaga: Pliki pojazdów pozostaną w obecnej firmie. Historia pobrań zostanie wyczyszczona, a harmonogramy pobrań zostaną usunięte.",
    "name": "Nazwa",
    "name not valid": "Nazwa nie może zawierać więcej niż {{maxNumber}} znaków",
    "name should not be empty": "Pole „Nazwa” nie może być puste",
    "name too short": "Nazwa musi zawierać co najmniej {{minNumber}} znaków",
    "optional": "opcjonalnie",
    "overwrite imei checkbox": {
      "description": "Ta opcja spowoduje usunięcie numeru IMEI z {{vehicleNumber}}.",
      "title": "Nadpisanie numeru IMEI."
    },
    "parent company": "Firma nadrzędna",
    "password": "Hasło",
    "password cannot contain more than": "Hasło nie może zawierać więcej niż {{maxNumber}} znaków",
    "past dates": {
      "1 month ago": "1 miesiąc temu",
      "1 week ago": "1 tydzień temu",
      "1 year ago": "1 rok temu",
      "multiple months ago": "{{monthCount}} miesięcy temu",
      "multiple weeks ago": "{{weekCount}} tygodni temu",
      "multiple years ago": "{{yearCount}} lat temu",
      "today": "Dzisiaj",
      "yesterday": "Wczoraj"
    },
    "port": "Port",
    "port must be between": "Wartość portu musi mieścić się w przedziale od {{minNumber}} do {{maxNumber}}",
    "previous month": "Poprzedni miesiąc",
    "provider": "Dostawca",
    "publish news": "Opublikować wiadomość?",
    "publish news description": "Ta wiadomość zostanie opublikowana. Czy na pewno chcesz kontynuować? Nie można cofnąć tej czynności.",
    "publish release notes": "Opublikować informacje o wydaniu?",
    "publish release notes description": "Informacje o aktualizacji zostaną opublikowane. Czy na pewno chcesz kontynuować? Tego działania nie można cofnąć.",
    "release notes": "Informacje o aktualizacji",
    "remote directory path cannot contain more than": "Ścieżka do katalogu zdalnego nie może zawierać więcej niż {{maxNumber}} znaków",
    "remote directory path optional": "Ścieżka do katalogu zdalnego (opcjonalnie)",
    "remove": "Usuń",
    "remove schedules": "Usuń harmonogramy",
    "remove schedules confirmation description": {
      "drivers multiple": "Czy na pewno chcesz usunąć harmonogramy {{resourceValue}} z wybranych kierowców?",
      "drivers single": "Czy na pewno chcesz usunąć {{resourceValue}} z wybranych kierowców?",
      "vehicles multiple": "Czy na pewno chcesz usunąć harmonogramy {{resourceValue}} z wybranych pojazdów?",
      "vehicles single": "Czy na pewno chcesz usunąć {{resourceValue}} z wybranych pojazdów?"
    },
    "remove schedules description": {
      "drivers": "Wybierz jeden lub więcej harmonogramów, które chcesz usunąć z wybranych kierowców.",
      "vehicles": "Wybierz jeden lub więcej harmonogramów, które chcesz usunąć z wybranych pojazdów."
    },
    "resend invitation": "Wyślij ponownie zaproszenie",
    "resend invitation description": "Czy na pewno chcesz ponownie wysłać zaproszenie do {{userEmail}}?",
    "role": "Rola",
    "schedule apply to all": {
      "drivers": "Wybrany harmonogram zostanie zastosowany wobec wszystkich kierowców w wybranej firmie.",
      "vehicles": "Wybrany harmonogram zostanie zastosowany do wszystkich pojazdów w wybranej firmie."
    },
    "schedule apply to filtered": {
      "drivers": "Wybrany harmonogram zostanie zastosowany do kierowców wybranych przy użyciu jednego lub kilku dostępnych filtrów.",
      "vehicles": "Wybrany harmonogram zostanie zastosowany do pojazdów wybranych przy użyciu jednego lub kilku dostępnych filtrów."
    },
    "schedule apply to selected": {
      "drivers": "Wybrany harmonogram zostanie zastosowany do wszystkich kierowców zaznaczonych za pomocą pola wyboru.",
      "vehicles": "Wybrany harmonogram zostanie zastosowany do wszystkich pojazdów zaznaczonych za pomocą pola wyboru."
    },
    "schedule time tooltip description": "Jeśli wybrana data dotyczy przeszłości, system automatycznie dostosuje go do nabliższej daty dostęnej w przyszłości.",
    "security settings": "Ustawienia zabezpieczeń",
    "security settings description": "Znajdź opcje, które pozwalają kontrolować sposób ochrony Twojego konta.",
    "select": "Wybierz",
    "select a company": "Wybierz firmę",
    "select file format example": "Wybierz format (np. .DDD)",
    "select format": "Wybierz format",
    "select image": "Wybierz zdjęcie",
    "select image description": "Wybierz obraz, którego chcesz użyć, klikając na niego i naciskając przycisk Zapisz.",
    "select schedules": "Wybierz harmonogramy",
    "selected resource": "Wybrane {{resource}}",
    "selected drivers": "Wybrani kierowcy",
    "selected vehicles": "Wybrane pojazdy",
    "selected role info message": "<3>Kliknij tutaj</3>, aby wyświetlić szczegółową tabelę uprawnień.",
    "selected role info message title": "Rola określa uprawnienia użytkowników w TachoSync.",
    "sftp integration": {
      "description": "Skonfiguruj połączenie SFTP i określ strukturę plików z tachografu.",
      "edit title": "Edytuj integrację SFTP „{{integrationName}}”",
      "sftp name": "Nazwa SFTP",
      "title": "Integracja SFTP"
    },
    "sftp password": "Hasło SFTP",
    "sftp server hostname or ip": "Nazwa hosta lub adres IP serwera SFTP",
    "sftp server port number": "Numer portu serwera SFTP",
    "sftp server settings": "Ustawienia serwera SFTP",
    "sftp username": "Nazwa użytkownika SFTP",
    "Teltonika code": "Kod Teltonika",
    "Teltonika code invalid characters": "Kod Teltonika musi mieć długość od {{minCount}} do {{maxCount}} znaków i może zawierać litery, cyfry oraz kropki.",
    "Teltonika code placeholder": "Kod Teltonika musi mieć długość od {{minCount}} do {{maxCount}} znaków",
    "Teltonika company name": "Nazwa firmy",
    "time": "Czas",
    "time zone": "Strefa czasowa",
    "title": "Tytuł",
    "title not valid": "Tytuł nie może zawierać więcej niż {{maxNumber}} znaków",
    "title should not be empty": "Tytuł nie może być pusty",
    "title too short": "Tytuł musi zawierać co najmniej {{minNumber}} znaków",
    "to": "Do",
    "toggle children global schedule linking": "Połączone z firmą macierzystą Globalny harmonogram",
    "toggle children global schedule linking tooltip": "Firma nadrzędna umożliwiła dziedziczenie harmonogramu globalnego. Aby edytować harmonogram globalny wybranej firmy, wyłącz tę opcję. Pamiętaj, że spowoduje to odłączenie harmonogramu globalnego od firmy nadrzędnej.",
    "toggle global schedule linking": "Zastosuj globalny harmonogram do wszystkich firm podrzędnych",
    "toggle global schedule linking tooltip": "Włączenie tej opcji powoduje zastosowanie harmonogramu globalnego do wszystkich firm podrzędnych . Firmy podrzędne mogą wyłączyć tę opcję, aby dostosować swój własny harmonogram globalny.",
    "toggle global schedule warning banner": "Niektóre firy podrzędne mogą już korzystać z innego harmonogramu globalnego. Ta opcja nie będzie miała na nie wpływu, chyba że zaznaczą ją w ustawieniach harmonogramu globalnego.",
    "unpublished release notes": "Istnieją niepublikowane informacje o wydaniu.",
    "upload folder blank for root": "Folder przesyłania (puste pole dla katalogu głównego)",
    "username": "Nazwa użytkownika",
    "username cannot contain more than": "Nazwa użytkownika nie może zawierać więcej niż {{maxNumber}} znaków",
    "vdo integration": {
      "add": {
        "description": "Skonfiguruj połączenie floty VDO.",
        "title": "Dodaj integrację floty VDO"
      },
      "edit": {
        "description": "Skonfiguruj połączenie floty VDO.",
        "title": "Edytuj integrację floty VDO"
      },
      "provider settings description": "Należy korzystać z danych uwierzytelniających dostarczonych przez VDO Fleet.",
      "provider settings title": "Ustawienia dostawcy"
    },
    "vehicle folder": "Folder pojazdu",
    "vehicle imei in use inaccessible": {
      "description": "Ten numer IMEI jest już przypisany do firmy spoza Twojej grupy. Jeśli urządzenie o tym numerze IMEI należy do Ciebie, skontaktuj się <supportLink>z pomocą techniczną Teltonika</supportLink>.",
      "title": "Numer IMEI używany przez inną grupę przedsiębiorstw"
    },
    "vehicle name": "Nazwa pojazdu",
    "vehicle number": "Numer rejestracyjny pojazdu (VRN)",
    "vehicle registration number tooltip": "W ustawieniach firmy włączono automatyczną aktualizację. Numer rejestracyjny pojazdu (VRN) wprowadzony w tym miejscu zostanie nadpisany wartością odczytaną z danych tachografu po pierwszym pomyślnym pobraniu.",
    "vehicles folder naming": "Nazwa folderu pojazdów",
    "vrn": "VRN",
    "vrn should not be empty": "Numer rejestracyjny pojazdu nie może być pusty",
    "welcome to beta version title": "Witamy w programie testów beta TachoSync!"
  },
  "Download history": {
    "download successful": "Pobieranie zakończone sukcesem",
    "driver data": "Dane kierowców",
    "no history": "W tym miejscu wyświetlana będzie historia",
    "schedule": "Harmonogram"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "Błąd odczytu pakietu APDU. Urządzenie odłączone.",
    "Authenticating": "Uwierzytelnianie",
    "Authentication failure (02x10)": "Błąd uwierzytelniania (02x10)",
    "Authentication failure after timeout (02x01)": "Błąd uwierzytelniania po upływie limitu czasu (02x01)",
    "Authentication failure after timeout (02x12)": "Błąd uwierzytelniania po upływie limitu czasu (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Błąd odczytu karty. Proszę ponownie włożyć kartę firmową, podłączyć ponownie czytnik kart lub zrestartować usługę.",
    "CheckingCredits": "Sprawdzanie środków",
    "CompanyCardExpired": "Karta firmowa straciła ważność",
    "CompanyCardInUse": "Karta firmowa w użyciu",
    "Could not download any of files": "Nie udało się pobrać żadnego z plików",
    "CreditReserved": "Prawa zastrzeżone",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Pobieranie odrzucone: numer VIN urządzenia nie zgadza się z numerem VIN tego pojazdu. Jeśli urządzenie zostało przeniesione do nowego pojazdu, utwórz nowy rekord pojazdu, aby kontynuować.",
    "DownloadingDriverData": "Pobieranie danych kierowców",
    "DownloadingDriverDataFailed": "Pobieranie danych kierowcy nie powiodło się",
    "DownloadingVehicleData": "Pobieranie danych z pojazdów",
    "Driver info packet reading error. Device disconnected.": "Błąd odczytu pakietu informacji o kierowcy. Urządzenie odłączone.",
    "Failed to download driver data": "Nie udało się pobrać danych kierowcy",
    "Failed to receive APDU from card, timeout exceeded": "Nie udało się odebrać pakietu APDU z karty, przekroczono limit czasu",
    "Failed to receive VUReady packet from device, timeout exceeded": "Nie udało się odebrać pakietu VUReady z urządzenia, przekroczono limit czasu",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Nie udało się odebrać pakietu VUReady. Jeśli problem nadal występuje, sprawdź konfigurację urządzeń telematycznych/tachografów.",
    "InsufficientCredits": "Niewystarczająca liczba kredytów",
    "Lost connection with device or card": "Utrata połączenia z urządzeniem lub kartą",
    "NoCompanyCards": "Brak kart firmowych",
    "NoDueSchedules": "Brak harmonogramów płatności",
    "NoSchedulesApplied": "Nie zastosowano żadnych harmonogramów",
    "ProcessTerminated": "Proces zakończony",
    "ReceivingDownloadList": "Pobieranie listy plików do pobrania",
    "ReceivingDriverInfo": "Pobieranie informacji o kierowcach",
    "ReceivingDriversSchedules": "Odbieranie harmonogramów kierowców",
    "ReceivingStatusState": "Stan odbioru",
    "ReceivingVehicleSchedules": "Odbieranie harmonogramów przejazdów pojazdów",
    "requirements": {
      "company card": "Karta firmowa",
      "credits available": "Dostępne środki",
      "ignition": "Zapłon",
      "ignition unavailable tooltip": "Nieznany - ostatni znany status miał miejsce ponad 2 godziny temu.",
      "imei": "IMEI",
      "schedule assigned": "Przypisany harmonogram",
      "vehicle activated": "Aktywowane przez pojazd",
      "reason": {
        "CompanyCardExpired": "Karta firmowa straciła ważność",
        "IgnitionNotReportedRecently": "Status nieznany - ostatnio nie zgłoszono stanu zapłonu. Próba pobrania plików nadal będzie podejmowana, ale prawdopodobieństwo powodzenia jest mniejsze",
        "IgnitionOff": "Zapłon jest wyłączony. Próba pobrania plików zostanie podjęta, ale prawdopodobieństwo powodzenia jest mniejsze",
        "InsufficientCredits": "Brak dostępnych kredytów",
        "NoCompanyCardOnline": "Obecnie żadna karta firmowa nie jest aktywna",
        "NoCompanyCards": "Obecnie żadna karta firmowa nie jest aktywna",
        "NoImeiAssigned": "Pojazd nie ma przypisanego numeru IMEI",
        "NoScheduleAssigned": "Pojazd musi mieć przypisany harmonogram",
        "VehicleDeactivated": "Aby pobrać dane, pojazd musi być aktywowany"
      }
    },
    "schedules": {
      "assign schedules": "Przypisywanie harmonogramów",
      "assign schedules dialog": {
        "description": "Wybierz jeden lub więcej harmonogramów, które chcesz przypisać.",
        "title": "Przypisz harmonogramy do {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "wymagania dotyczące pobierania nie zostały spełnione."
      },
      "no schedules assigned": "Do tego pojazdu nie przypisano żadnych harmonogramów",
      "on device connection": "po podłączeniu urządzenia",
      "requirements not met": "Harmonogram nie może zostać zrealizowany, dopóki nie zostaną spełnione wszystkie wymagania."
    },
    "StageComplete": "Etap zakończony",
    "Stages": {
      "Authentication": "Uwierzytelnianie",
      "Downloading": "Pobieranie",
      "DownloadTrigger": "Wyzwalacz pobierania",
      "Initialization": "Inicjalizacja"
    },
    "Status packet reading error. Device disconnected.": "Błąd odczytu pakietu stanu. Urządzenie odłączone.",
    "TerminatingConnectionToDevice": "Zakończenie połączenia z urządzeniem",
    "Timeout. Response from VU not received (02x01)": "Przekroczono limit czasu. Nie otrzymano odpowiedzi z jednostki pojazdowej (02x01)",
    "Too many KeepAlive packets received.": "Otrzymano zbyt wiele pakietów KeepAlive.",
    "Unexpected error": "Nieoczekiwany błąd",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Niespodziewana utrata połączenia z urządzeniem. Gdy urządzenie przywróci normalną łączność, pobieranie zostanie wznowione.",
    "UploadingDriverFiles": "Przesyłanie plików kierowców",
    "UploadingDriverFilesFailed": "Nie udało się przesłać plików kierowców",
    "UploadingVehicleFiles": "Przesyłanie plików pojazdów",
    "UploadingVehicleFilesFailed": "Nie udało się przesłać plików pojazdu",
    "VehicleDeactivated": "Pojazd wyłączony",
    "VuNotReady": "VU nie jest gotowe. Ponowna próba za 5 minut",
    "VU ready packet reading error. Device disconnected.": "Błąd odczytu pakietu w trybie VU. Urządzenie odłączone.",
    "WaitingForDeviceConnection": "Oczekiwanie na połączenie z urządzeniem",
    "Wrong communication command": "Nieprawidłowe polecenie komunikacyjne"
  },
  "Drivers": {
    "drivers page": "Kierowcy",
    "last activity": {
      "Available": "Dostępne",
      "BreakOrRest": "Przerwa/Odpoczynek",
      "Drive": "Jazda",
      "NotAvailable": "Niedostępne",
      "Undefined": "Nie dotyczy",
      "Unknown": "Nieznane",
      "Unknown4": "Nieznane",
      "Unknown5": "Nieznane",
      "Work": "Praca"
    }
  },
  "Dropzone": {
    "add file": "Dodaj plik",
    "drop file to upload": "Przeciągnij plik, aby go przesłać",
    "drop files to upload": "Przeciągnij pliki, aby je przesłać",
    "error uploading the file": "Wystąpił błąd podczas przesyłania pliku",
    "file invalid type": "Wybrano nieprawidłowy typ pliku.",
    "file successfully uploaded": "Plik został pomyślnie przesłany",
    "file syntax": "Składnia pliku jest następująca:",
    "maximum file limit reached": "Osiągnięto maksymalny limit plików.",
    "no image": "Brak obrazu",
    "only one file can be attached": "Można załączyć tylko jeden plik.",
    "or drop file to upload": "Lub przeciągnij plik, aby go przesłać",
    "or drop files to upload": "Lub przeciągnij pliki, aby je przesłać",
    "row limit exceeded": "Osiągnięto limit importu zasobów. Nie można zaimportować więcej niż {{rowLimit}} zasobów.",
    "rows detected": "Pomyślnie wykryto wiersze w pliku.",
    "select file": "Wybierz plik",
    "select file type": "Proszę najpierw wybrać typ pliku.",
    "select files": "Wybierz pliki",
    "select image": "Wybierz obraz:",
    "supported formats": "Obsługiwane formaty",
    "too long file name": "Nazwa pliku jest zbyt długa. Dopuszczalna maksymalna długość to {{maxLength}} znaków.",
    "too many files description": "Pozostałe pliki można przesłać po przesłaniu wybranych plików.",
    "too many files title": "Maksymalna liczba plików, które można załączyć jednocześnie, wynosi {{maxFiles}}."
  },
  "Error": {
    "error": "Błąd",
    "message wait": "Prosimy o cierpliwość, dopóki nie naprawimy tego błędu.",
    "title": "Coś poszło nie tak!"
  },
  "Files": {
    "files header info tooltip": "Pobrane pliki są przechowywane w TachoSync przez dwa lata, po czym są automatycznie usuwane z systemu."
  },
  "Filter": {
    "company": "Firma",
    "credit status": "Status kredytowy",
    "deactivatedVehicles": "Pojazdy wyłączone z eksploatacji",
    "device imei": "Numer IMEI urządzenia",
    "device status": "Stan urządzenia",
    "driver": "Kierowca",
    "filtered by": "Filtrowane według",
    "filters used": "Zastosowane filtry",
    "from to date": "{{fromDate}} do {{toDate}}",
    "last activity": "Ostatnia aktywność",
    "last download": "Ostatnie pobranie",
    "last download options": {
      "DueSoon": "Wkrótce",
      "NoDownloads": "Brak pobrań",
      "OnTime": "Na czas",
      "Overdue": "Przeterminowane",
      "Undefined": "Nie dotyczy"
    },
    "more filters": "Więcej filtrów",
    "noDeviceImei": "Brak numeru IMEI urządzenia",
    "Not reserved": "Nie zarezerwowane",
    "Reserved": "Zastrzeżone",
    "schedule": "Harmonogram",
    "schedule name": "Nazwa harmonogramu",
    "schedules": "Harmonogramy",
    "select date": "Wybierz datę",
    "select date and time": "Wybierz datę i godzinę",
    "Select date range": "Wybierz zakres dat",
    "status": "Status",
    "table filters": "Filtry tabeli",
    "vehicle number": "Numer pojazdu"
  },
  "General": {
    "Active": "Aktywne",
    "Administrator": "Administrator",
    "administrator role description": "Pełna kontrola nad tworzeniem, edycją i usuwaniem wszystkich zasobów.",
    "analysis provider": "Dostawca usług analitycznych",
    "analysis providers": "Dostawcy usług analitycznych",
    "api credential": "Dane uwierzytelniające API",
    "api credentials": "Dane uwierzytelniające API",
    "Available": "Dostępne",
    "Awaiting connection": "Oczekiwanie na połączenie",
    "badge": {
      "connected badge tooltip text": "Połączono z TachoSync i trwa komunikacja.",
      "deactivated badge tooltip text": "Ten pojazd jest wyłączony i nie będzie zużywał kredytów.",
      "inactive badge tooltip text": "Nigdy nie nawiązano połączenia z TachoSync.",
      "offline badge tooltip text": "Nie łączył się z TachoSync w ciągu ostatnich 24 godzin",
      "online badge tooltip text": "Połączono w ciągu ostatnich 24 godzin"
    },
    "Blocked": "Zablokowane",
    "BreakOrRest": "Przerwa/Odpoczynek",
    "business": "Biznes",
    "code expired": "Twoja sesja wygasła. Zaloguj się ponownie.",
    "column": "Kolumna",
    "companies": "Firmy",
    "company": "Firma",
    "Company administrator": "Administrator firmy",
    "Connected": "Połączone",
    "credits": "Kredyty",
    "dashboard": "Pulpit nawigacyjny",
    "Deactivated": "Dezaktywowane",
    "Description": "Opis",
    "Disabled": "Wyłączone",
    "Disconnected": "Rozłączone",
    "Drive": "Jazda",
    "driver data": "Dane kierowcy",
    "drivers": "Kierowcy",
    "DueSoon": "Wkrótce",
    "end": "Koniec",
    "Expired": "Wygasło",
    "Failed": "Nie powiodło się",
    "files": "Pliki",
    "here": "tutaj",
    "history": "Historia",
    "Inactive": "Nieaktywne",
    "in progress": "w toku",
    "integration": "Integracja",
    "integrations": "Integracje",
    "integrations/analysisProviders": "Dostawcy usług analitycznych",
    "integrations/apicredentials": "Dane uwierzytelniające API",
    "Interrupted": "Przerwane",
    "InvalidConfiguration": "Nie powiodło się",
    "invitations": "Zaproszenia",
    "latest version": "Najnowsza wersja",
    "menu": "Menu",
    "NoDownloads": "Brak pobrań",
    "not assigned": "Nie przypisano",
    "Not reserved": "Nie zarezerwowane",
    "NotAvailable": "Niedostępne",
    "NotReserved": "Nie zarezerwowane",
    "Offline": "Tryb offline",
    "Online": "Online",
    "OnTime": "Na czas",
    "Pending": "W toku",
    "requirements": "Wymagania",
    "Reserved": "Zastrzeżone",
    "row": "Wiersz",
    "schedule": "Harmonogram",
    "schedules": "Harmonogramy",
    "show older": "Pokaż starsze",
    "start": "Start",
    "Successful": "Powodzenie",
    "Teltonika support": "Pomoc techniczna Teltoniki",
    "Teltonika Support": "Pomoc techniczna Teltoniki",
    "teltonika support role description": "Specjalistyczny dostęp dla pomocy technicznej.",
    "Tooltip": {
      "accept beta terms": "Aby kontynuować, przewiń na dół strony i zaakceptuj warunki."
    },
    "unauthorized": "Nie udało się uwierzytelnić użytkownika",
    "Undefined": "Nie dotyczy",
    "Unknown": "Nieznane",
    "Unknown4": "Nieznane",
    "Unknown5": "Nieznane",
    "User": "Użytkownik",
    "user role description": "Dostęp podstawowy z ograniczonymi uprawnieniami.",
    "users": "Użytkownicy",
    "vehicles": "Pojazdy",
    "Work": "Praca",
    "year": "Rok"
  },
  "Languages": {
    "english": "angielski",
    "french": "francuski",
    "language": "Język"
  },
  "Navigation": {
    "collapse menu": "Zwiń menu",
    "expand menu": "Rozwiń menu"
  },
  "News": {
    "create news": "Utwórz wiadomość",
    "delete": "Usuń",
    "edit": "Edytuj",
    "publish": "Opublikuj",
    "unpublished": "Niepublikowane"
  },
  "Notifications": {
    "notifications": "Powiadomienia"
  },
  "Password": {
    "account password": "Hasło do konta",
    "are you sure": "Jesteś pewien?",
    "change": "Zmień",
    "change password": "Zmień hasło",
    "click to scan code": "Kliknij tutaj, aby zeskanować kod QR",
    "click to type code": "Kliknij tutaj, aby ręcznie wpisać kod",
    "disable description confirmation": "Zamierzasz wyłączyć uwierzytelnianie dwuskładnikowe. Może to spowodować, że Twoje konto TachoSync stanie się niezabezpieczone. Czy na pewno chcesz kontynuować?",
    "disable description send code": "Do Twojej aplikacji uwierzytelniającej został wysłany 6-cyfrowy kod. Ze względów bezpieczeństwa wprowadź wygenerowany kod w polu poniżej.",
    "disable description send password": "Ze względów bezpieczeństwa prosimy o ponowne wprowadzenie aktualnego hasła.",
    "disable no access": "Jeśli nie masz już dostępu do aplikacji uwierzytelniającej powiązanej z tym kontem, konieczna jest zmiana hasła w celu wyłączenia uwierzytelniania dwuskładnikowego.",
    "disabled": "Wyłączone",
    "disabled two FA": "Udało się wyłączyć uwierzytelnianie dwuskładnikowe.",
    "enabled": "Włączone",
    "enter": "Wprowadź",
    "enter current password": "Wprowadź aktualne hasło",
    "generate key description": "Aby zakończyć ten proces, potrzebna będzie aplikacja mobilna do uwierzytelniania, na przykład jedna z poniższych:",
    "incorrect code": "Nieprawidłowy kod",
    "incorrect password": "Nieprawidłowe hasło",
    "lowercase letter": "Co najmniej jedna mała litera (a-z)",
    "minimum characters": "Co najmniej {{maxNumber}} znaków",
    "minimum digits": "Co najmniej jedna liczba",
    "password": "Hasło",
    "password too long": "Hasło nie może zawierać więcej niż {{maxNumber}} znaków",
    "passwords must match": "Hasła muszą się zgadzać",
    "reset password success": "Twoje hasło zostało zmienione.",
    "scan QR code": "Zeskanuj kod QR w swojej aplikacji",
    "six digit code": "6-cyfrowy kod wygenerowany przez aplikację",
    "special character": "Co najmniej jeden znak specjalny (!@#$%^&*()-_=+)",
    "success description": "Pomyślnie włączono uwierzytelnianie dwuskładnikowe.",
    "two-factor authentication": "Uwierzytelnienie dwuskładnikowe",
    "two-factor authentication description": "Uwierzytelnienie dwuskładnikowe to dodatkowa warstwa zabezpieczeń, która weryfikuje tożsamość użytkownika na podstawie czegoś, co użytkownik wie (hasło) oraz czegoś, co posiada (telefon, klucz bezpieczeństwa).",
    "two-factor authentication enabled": "Udało się włączyć uwierzytelnianie dwuskładnikowe.",
    "two-factor authentication status": "Uwierzytelnianie dwuskładnikowe to:",
    "type text code": "Wpisz kod tekstowy do swojej aplikacji",
    "uppercase letter": "Co najmniej jedna wielka litera (A-Z)"
  },
  "Schedules": {
    "activities from": "Działania z zakresu",
    "activities to": "Działania w zakresie",
    "apply button tooltip": "Wybierz co najmniej jeden {{resourceName}} i zaplanuj zastosowanie.",
    "confirm bulk quick schedule": "Zamierzasz utworzyć szybki harmonogram dla wybranych kierowców. Czy chcesz kontynuować?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Wybrano kierowców, ale nie wybrano ani nie zastosowano żadnego harmonogramu. Czy na pewno chcesz kontynuować?",
          "selected": "Wybrałeś harmonogram, ale go nie zastosowałeś. Czy chcesz zastosować harmonogram do wybranych kierowców?"
        },
        "vehicles": {
          "not selected": "Wybrałeś pojazdy, ale nie wybrano ani nie zastosowano żadnego harmonogramu. Czy na pewno chcesz kontynuować?",
          "selected": "Wybrałeś harmonogram, ale go nie zastosowałeś. Czy chcesz zastosować harmonogram do wybranych pojazdów?"
        }
      },
      "title": {
        "not selected": "Nie wybrano ani nie zastosowano żadnego harmonogramu.",
        "selected": "Harmonogram nie został zastosowany"
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Czy na pewno chcesz usunąć harmonogram „{{scheduleName}}”? Ta czynność jest nieodwracalna i wpłynie na wszystkich kierowców, których dotyczy ten harmonogram.",
        "vehicles": "Czy na pewno chcesz usunąć harmonogram „{{scheduleName}}”? Ta czynność jest nieodwracalna i wpłynie na wszystkie pojazdy, do których zastosowano ten harmonogram."
      },
      "title": "Usunąć harmonogram?"
    },
    "create new schedule": "Utwórz nowy harmonogram",
    "data types": "Typy danych",
    "days": "dni",
    "details remove schedule": {
      "description": "Czy na pewno chcesz usunąć harmonogram „{{scheduleName}}”?",
      "title": "Usunąć harmonogram?"
    },
    "download activities": {
      "date info tooltip": "Zakres dat aktywności musi obejmować co najmniej dwa dni.",
      "tooltip text": "TachoSync wykorzystuje adaptacyjny zakres pobierania danych, zapewniający ciągłość poprzez automatyczne dostosowywanie okresu pobierania na podstawie ostatniego pomyślnego pobrania danych. Minimalizuje to luki i gwarantuje, że zawsze dysponujesz najnowszymi danymi, nawet jeśli zaplanowane pobieranie nie zostanie zakończone przez kilka dni."
    },
    "driver number": "Kierowca {{driverNum}}",
    "driver schedules": {
      "description": "Harmonogramy kierowców pozwalają zautomatyzować pobieranie danych z tachografów dla wybranych kierowców. Wybierz kierowców, do których chcesz zastosować harmonogram. Wybierz harmonogram z listy i kliknij „Zastosuj”, aby go aktywować. W razie potrzeby możesz tworzyć, edytować i usuwać harmonogramy. Uwaga: każda firma może mieć jednocześnie maksymalnie 3 harmonogramy kierowców.",
      "description read-only": "Harmonogramy kierowców umożliwiają automatyczne pobieranie danych z tachografów dla wybranych kierowców. Administratorzy firmy mogą tworzyć, edytować i usuwać harmonogramy w zależności od potrzeb.",
      "title": "Harmonogramy kierowców"
    },
    "due date": "Termin",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo dodanych kierowców. Można to zmienić w ustawieniach ogólnych.",
          "not global": "Zmiany wprowadzone w tym harmonogramie będą miały wpływ na wszystkich kierowców, których dotyczy ten harmonogram."
        },
        "vehicles": {
          "global": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo dodanych pojazdów. Można to zmienić w ustawieniach ogólnych.",
          "not global": "Zmiany wprowadzone w tym harmonogramie będą miały wpływ na wszystkie pojazdy, do których harmonogram ten ma zastosowanie."
        }
      },
      "title": {
        "global": "Harmonogram globalny",
        "not global": "Edytuj harmonogram"
      }
    },
    "enter days": "Wprowadź dni",
    "every": "Każdy",
    "fail reason": "Przyczyna niepowodzenia",
    "file types": {
      "Activities": "Działalność",
      "DetailedSpeed": "Szczegółowa prędkość",
      "EventsAndFaults": "Zdarzenia i usterki",
      "Overview": "Przegląd",
      "TechnicalData": "Dane techniczne"
    },
    "global schedule": {
      "connected to root company": "Połączone z globalnym harmonogramem firmy macierzystej.",
      "global icon info": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo zarejestrowanych {{specificGlobalSchedule}}. Opcję tę można wyłączyć w ustawieniach firmy.",
      "info": {
        "edit driver schedule": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo zarejestrowanych kierowców. Opcję tę można wyłączyć w ustawieniach firmy.",
        "edit schedule": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo zarejestrowanych {{variableName}}. Opcję tę można wyłączyć w ustawieniach firmy.",
        "edit vehicle schedule": "Globalny harmonogram zostanie automatycznie zastosowany do wszystkich nowo zarejestrowanych pojazdów. Opcję tę można wyłączyć w ustawieniach firmy."
      },
      "inherited settings": "Ustawienia harmonogramu firmy nadrzędnej są automatycznie przenoszone na wszystkie firmy podrzędne.",
      "not configured description": "Naciśnij przycisk Edytuj, aby rozpocząć konfigurację harmonogramu globalnego.",
      "not configured description read-only": "Szczegóły harmonogramu pojawią się po jego skonfigurowaniu.",
      "not configured title": "Globalny harmonogram nie został skonfigurowany.",
      "not connected to root company": "Brak połączenia z globalnym harmonogramem firmy macierzystej."
    },
    "include driver data": "Uwzględnij dane kierowców",
    "include driver data tooltip": "Wybierz, czy harmonogram szybkiego pobierania ma również pobierać dane z karty kierowcy dla kierowców, których karty są aktualnie włożone do tachografu w momencie wykonywania zadania.\n<ul><li>Brak – Pobierane będą wyłącznie dane pojazdu (VU).</li><li>Kierowca 1 / Kierowca 2 – Pobierz dane z wybranego gniazda tachografu, jeśli znajduje się w nim karta kierowcy.</li><li>Obaj kierowcy – Pobierz dane z obu gniazd, jeśli karty są obecne.</li></ul>Jeśli w momencie wykonywania operacji w wybranym gnieździe nie jest włożona żadna karta kierowcy, dane kierowcy nie zostaną pobrane.",
    "max number reached": "Osiągnąłeś maksymalną liczbę dozwolonych harmonogramów.",
    "name not valid": "Nazwa harmonogramu nie może zawierać więcej niż {{maxNumber}} znaków",
    "next attempt": "Kolejna próba",
    "next date": "Następna data",
    "next date and time": "Następna data i godzina",
    "next due date": "Następny termin",
    "quick schedule": {
      "description": "Wybierz typy danych, które chcesz pobrać.",
      "driver schedule quick download new": "Tworzy jednorazowy harmonogram pobierania plików kierowców. Zostanie on wykonany, gdy tylko kierowca połączy się z aplikacją.",
      "info banner": {
        "drivers": "Jest to harmonogram jednorazowy. Pobieranie danych kierowcy rozpocznie się, gdy tylko zostanie wykryte połączenie kierowcy z TachoSync.",
        "vehicles": "Jest to harmonogram jednorazowy. Pobieranie danych z pojazdu rozpocznie się natychmiast po wykryciu połączenia pojazdu z TachoSync."
      },
      "success banner": "Harmonogram został zrealizowany, można go usunąć, klikając „Usuń harmonogram”",
      "title": "Szybki harmonogram",
      "vehicle schedule quick download deactivated": "Szybkiego harmonogramu nie można uruchomić w przypadku pojazdów wyłączonych. Jeśli chcesz rozpocząć nowy szybki harmonogram, najpierw włącz pojazd.",
      "vehicle schedule quick download new": "Tworzy jednorazowy harmonogram pobierania plików z pojazdu. Zostanie on wykonany, gdy tylko pojazd połączy się z aplikacją."
    },
    "repeat": "Powtórz",
    "repeat every": "Powtarzaj co",
    "repeat period": {
      "Biweekly": "Co 14 dni",
      "Custom": "Niestandardowe",
      "Daily": "Codziennie",
      "Every28Days": "Co 28 dni",
      "Every90Days": "Co 90 dni",
      "EveryDays": "Co {{count}} dni",
      "Hourly": "Co godzinę",
      "Monthly": "Miesięcznie",
      "Weekly": "Co 7 dni"
    },
    "schedule details": "Szczegóły dotyczące „{{scheduleName}}”",
    "select date": "Wybierz datę",
    "start date": "Data rozpoczęcia",
    "start date and time": "Data i godzina rozpoczęcia",
    "vehicle schedules": {
      "description": "Harmonogramy pojazdów pozwalają zautomatyzować pobieranie danych z tachografów dla wybranych pojazdów. Wybierz pojazdy, do których chcesz zastosować harmonogram. Wybierz harmonogram z listy i kliknij „Zastosuj”, aby go aktywować. W razie potrzeby możesz tworzyć, edytować i usuwać harmonogramy. Uwaga: Każda firma może mieć maksymalnie 3 harmonogramy pojazdów jednocześnie.",
      "description read-only": "Harmonogramy pojazdów umożliwiają automatyczne pobieranie danych z tachografów dla wybranych pojazdów. Administratorzy firmy mogą tworzyć, edytować i usuwać harmonogramy w zależności od potrzeb.",
      "download data activities tooltip hourly": "Działania zostaną pobrane dla bieżącego dnia",
      "download data activities tooltip monthly": "Przed każdą datą uruchomienia pobierane będą dane dotyczące całego poprzedniego miesiąca",
      "download data activities tooltip multiple": "Działania zostaną pobrane z ostatnich {{repeatDays}} dni poprzedzających każdą datę uruchomienia",
      "download data activities tooltip single": "Działania zostaną pobrane za ostatni dzień poprzedzający każdą datę przejazdu",
      "title": "Harmonogramy pojazdów"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "Numer IMEI musi składać się z 15 znaków",
      "find device": "Znajdź urządzenie",
      "no vehicle found": "Nie znaleziono pojazdu",
      "no vehicle found description": "Nie znaleziono pojazdu. Spróbuj wpisać inny numer IMEI urządzenia.",
      "only numbers": "Dopuszczalne są wyłącznie liczby",
      "search for vehicles by their IMEI": "Wyszukiwanie pojazdów na podstawie numeru IMEI urządzenia",
      "search vehicle IMEI": "Wyszukiwanie urządzenia według numeru IMEI"
    },
    "search": "Wyszukaj...",
    "search child company": "Wyszukaj spółkę zależną",
    "search company name": "Wyszukaj nazwę firmy",
    "search in driverFiles": "Wyszukiwanie według kierowcy lub identyfikatora kierowcy",
    "search in drivers": "Wyszukiwanie według nazwy lub identyfikatora kierowcy",
    "search in integrations": "Wyszukiwanie według nazwy",
    "search in users": "Wyszukiwanie według adresu e-mail",
    "search in vehicleFiles": "Wyszukiwanie według numeru IMEI lub VRN urządzenia FM",
    "search in vehicles": "Wyszukiwanie według numeru IMEI lub VRN urządzenia FM"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Użyj tego kodu na następnym ekranie, aby zweryfikować swoje konto.",
        "description modal": "Użyj tego kodu, aby zweryfikować swoje konto.",
        "title": "Po naciśnięciu przycisku „Wyślij kod” unikalny kod zostanie wysłany na adres <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Uzyskaj unikalny kod z aplikacji takiej jak Microsoft Authenticator lub Google Authenticator.",
        "description": "Aby zapewnić bezpieczeństwo swojego konta i danych klientów, skorzystaj z jednej z poniższych opcji, aby skonfigurować uwierzytelnianie dwuskładnikowe.",
        "description modal": "Wybierz preferowaną metodę uwierzytelniania.",
        "email": "E-mail",
        "email description": "Za każdym razem, gdy spróbujesz się zalogować, wyślemy jednorazowy kod na Twój adres e-mail.",
        "recommended": "Polecane",
        "title": "Uwierzytelnianie dwuskładnikowe (2FA) jest obowiązkowe dla wszystkich użytkowników TachoSync.",
        "title modal": "Wybierz metodę uwierzytelniania"
      },
      "send email code": {
        "description": "Wpisz kod w polu poniżej i naciśnij „Weryfikuj”, aby kontynuować.",
        "enter code": "Wprowadź kod, aby zweryfikować adres e-mail.",
        "title": "Unikalny kod został wysłany na adres <1>{{email}}</1>.",
        "verification code": "Kod weryfikacyjny"
      },
      "send otp code": {
        "click to scan code": "Kliknij tutaj, aby zeskanować kod QR",
        "click to type code": "Kliknij tutaj, aby ręcznie wpisać kod",
        "incorrect code": "Nieprawidłowy kod",
        "scan QR code": "Zeskanuj kod QR w swojej aplikacji",
        "six digit code": "6-cyfrowy kod wygenerowany przez aplikację",
        "title": "Aby zakończyć ten proces, potrzebna będzie aplikacja mobilna do uwierzytelniania, taka jak: <1>Microsoft Authenticator</1> lub <2>Google Authenticator</2>.",
        "type text code": "Wpisz kod tekstowy do swojej aplikacji"
      },
      "success message": {
        "alert": "Udało się włączyć uwierzytelnianie dwuskładnikowe.",
        "description": "Za każdym razem, gdy logujesz się przy użyciu adresu e-mail i hasła, będziemy prosić o podanie kodu uwierzytelniającego.",
        "title": "Pomyślnie włączono uwierzytelnianie dwuskładnikowe.",
        "title modal": "Włączono uwierzytelnianie dwuskładnikowe!"
      },
      "title": {
        "authentication app": "Aplikacja do uwierzytelniania",
        "authentication email": "E-mail uwierzytelniający",
        "is enabled": "Włączono uwierzytelnianie dwuskładnikowe.",
        "protect your account": "Chroń swoje konto TachoSync"
      }
    }
  },
  "Selector": {
    "client company": "Firma klienta",
    "companies": "Firmy ({{companyCount}})",
    "company selector": "Wybór firmy"
  },
  "Settings": {
    "CCA file size": "Rozmiar pliku 83,5 MB",
    "change password": "Zmień hasło",
    "company card authenticator": "Autentyfikator karty firmowej",
    "email notifications": {
      "credits purchased": "Zakupione kredyty",
      "low credits alerts": "Powiadomienia o niskim stanie środków",
      "title": "Powiadomienia e-mailowe",
      "tooltip": "Zarządzaj tym, jakie wiadomości e-mail dotyczące kredytu chcesz otrzymywać."
    },
    "feature switches": "Przełączniki funkcji",
    "file format settings": {
      "description": "Wybierz format, w jakim mają być wyświetlane pliki z tachografu. Dostępne formaty to europejski (.DDD), francuski (.V1B dla danych pojazdu i .C1B dla danych kierowcy) oraz hiszpański (.TGD).",
      "title": "Ustawienia formatu plików"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Ustawienia ogólne",
    "security": "Bezpieczeństwo",
    "time settings": {
      "date display format tooltip": "Wybierz format wyświetlania daty w programie TachoSync.\nNp.: DD-MM-RRRR = 14-05-2024",
      "description": "Ustaw strefę czasową automatycznie na podstawie aktualnej lokalizacji lub wybierz preferowaną strefę czasową oraz format, w jakim będą wyświetlane wszystkie znaczniki czasu.",
      "time and date format toggle": "Automatyczne ustawianie formatu godziny i daty",
      "title": "Ustawienia czasu"
    },
    "tutorials": "Samouczki",
    "version": "Wersja"
  },
  "Table": {
    "activity period": "Okres działalności",
    "Automatic initial Driver Download": "Automatyczne pobieranie danych początkowych kierowcy",
    "Automatic initial Vehicle Download": "Automatyczne pobieranie danych z pojazdu",
    "card name": "Nazwa",
    "card number": "Identyfikator kierowcy",
    "cardnumber": "Identyfikator kierowcy",
    "comment": "Komentarz",
    "company": "Firma",
    "connection status": "Stan połączenia",
    "created at": "Utworzono w",
    "created by": "Stworzone przez",
    "credit status": "Status kredytowy",
    "data types": "Typy danych",
    "day ago": "1 dzień temu",
    "days ago": "{{daysNum}} dni temu",
    "description": "Opis",
    "device imei": "Numer IMEI urządzenia",
    "device imei empty": "Pojazd nie ma dodanego numeru IMEI. Prawidłowy numer IMEI jest niezbędny do połączenia urządzenia i pobrania plików. Przejdź do edycji pojazdu i dodaj prawidłowy numer IMEI, aby umożliwić pobieranie plików z pojazdu.",
    "device status": "Stan urządzenia",
    "downloaded at": "Pobrano o godz.",
    "driver": "Kierowca",
    "driver name": "Imię i nazwisko kierowcy",
    "drivers name": "Imię i nazwisko kierowcy",
    "email": "E-mail",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Dodaj integrację",
          "driver files": "Dodaj plik kierowcy",
          "drivers": "Dodaj kierowcę",
          "integrations": "Dodaj integrację",
          "integrations api": "Dodaj integrację",
          "users": "Zaproś użytkownika",
          "vehicle files": "Dodaj plik pojazdu",
          "vehicles": "Dodaj pojazd"
        },
        "reset view": "Wyczyść widok"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Gdy tylko dostawcy usług analitycznych zostaną dodani do TachoSync, \nbędziesz mógł zobaczyć ich listę tutaj.",
          "companies": "Gdy tylko firmy zostaną dodane do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "company cards": "Gdy tylko dodasz karty firmowe, ich lista będzie widoczna tutaj.",
          "driver files": "Gdy tylko pliki kierowców zostaną dodane do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "drivers": "Gdy tylko kierowcy zostaną dodani do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "integrations": "Gdy tylko integracje zostaną dodane do TachoSync, \nbędziesz mógł zobaczyć ich listę tutaj.",
          "integrations api": "Gdy tylko klucze API zostaną utworzone dla Twojej firmy,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "users": "Gdy tylko użytkownicy zostaną dodani do TachoSync, \nbędziesz mógł zobaczyć ich listę tutaj.",
          "users invitations": "Gdy tylko użytkownicy zostaną zaproszeni do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "vehicle files": "Gdy tylko pliki pojazdów zostaną dodane do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj.",
          "vehicles": "Gdy tylko pojazdy zostaną dodane do TachoSync,\nbędziesz mógł zobaczyć ich listę tutaj."
        },
        "title": {
          "analysis providers": "Brak dostawców usług analitycznych",
          "companies": "Tabela firm jest pusta",
          "company cards": "Tabela kart firmowych jest pusta",
          "driver files": "Tabela plików kierowców jest pusta",
          "drivers": "Tabela kierowców jest pusta",
          "integrations": "Brak integracji",
          "integrations api": "Brak kluczy API",
          "users": "Tabela użytkowników jest pusta",
          "users invitations": "Tabela zaproszeń użytkowników jest pusta",
          "vehicle files": "Tabela plików pojazdów jest pusta",
          "vehicles": "Tabela pojazdów jest pusta"
        }
      },
      "no results found": {
        "description": "Wypróbuj inne słowo kluczowe lub filtr, aby uzyskać więcej \nwyników.",
        "title": "Nie znaleziono wyników"
      }
    },
    "enable": "Włącz",
    "expiration date": "Data ważności",
    "expired integration tooltip": "Integracja wygasła i nie można jej włączyć",
    "file name": "Nazwa pliku",
    "Global schedule": "Harmonogram globalny",
    "imei": "IMEI",
    "invitation status": "Status zaproszenia",
    "invited at": "Zaproszony na",
    "invited by": "Na zaproszenie",
    "last activity": "Ostatnia aktywność",
    "last connected": "Ostatnie połączenie",
    "last connection": "Ostatnie połączenie",
    "last download": "Ostatnie pobranie",
    "last download date": "Ostatnie pobranie: {{date}}",
    "last event": "Ostatnie wydarzenie",
    "last vehicle used": "Ostatnio używany pojazd",
    "method": "Metoda",
    "name": "Nazwa",
    "next download": "Następne pobranie",
    "No schedule applied": "Nie zastosowano harmonogramu",
    "No schedules": "Brak harmonogramów",
    "number": "Liczba",
    "Overdue": "Zaległy",
    "parent company": "Firma nadrzędna",
    "plate number": "Numer rejestracyjny",
    "provider": "Dostawca",
    "Quick schedule": "Szybki harmonogram",
    "role": "Rola",
    "rows per page": "Liczba wierszy na stronie",
    "schedule": "Harmonogram",
    "schedules": "Harmonogramy",
    "seen at": "Widziane w",
    "select columns to show": "Wybierz kolumny do wyświetlenia",
    "show details": {
      "companies": "Pokaż dane firmy",
      "drivers": "Pokaż dane kierowcy",
      "integrations": "Pokaż szczegóły integracji",
      "vehicles": "Pokaż szczegóły pojazdu"
    },
    "status": "Status",
    "today": "Dzisiaj",
    "updated at": "Zaktualizowano",
    "vehicle": "Pojazd",
    "vehicle name": "Nazwa pojazdu",
    "vehicle number": "VRN",
    "vehicles": "Pojazdy"
  },
  "Tabs": {
    "analysis providers": "Dostawcy usług analitycznych",
    "api": "API",
    "invitations": "Zaproszenia",
    "sftp": "SFTP",
    "users": "Użytkownicy"
  },
  "Tooltip": {
    "delete company action": "Jedna lub więcej wybranych firm ma spółki zależne i nie można ich usunąć. Aby usunąć wybrane firmy, należy najpierw usunąć wszystkie spółki zależne.",
    "no action permission": "Nie masz uprawnień do wykonania tej czynności",
    "parent company": "Maksymalna dozwolona liczba poziomów w drzewie struktury firmy wynosi {{maxAllowedLevels}}. Firma „{{companyName}}” znajduje się na {{maxAllowedLevels}}. poziomie i nie można do niej dodawać żadnych firm podrzędnych."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Aby dodać nową kartę firmową, kliknij podświetlony przycisk „Dodaj<strong> </strong>nową”. Gdy pojawi się ekran dodawania firmy, wypełnij wymagane pola i kliknij przycisk „Zapisz”, aby zakończyć.\n\nUwaga: Identyfikator karty firmowej można znaleźć w aplikacji Company Card Authenticator, w kolumnie „Identyfikator karty”.\n\nKliknij „<strong>D</strong>ale<strong>j</strong>”, aby kontynuować.",
          "title": "Dodaj nową kartę przedsiębiorstwa"
        },
        "final step": {
          "content": "Wszystkie dodane karty wraz z ich szczegółami zostaną wyświetlone w sekcji „Karty firmowe”.\n\nUwaga: W każdej chwili możesz powtórzyć ten samouczek, przechodząc do sekcji „Ustawienia” – „Samouczki”. \n\nKliknij „Zakończ”, aby zakończyć samouczek.",
          "title": "Dane karty przedsiębiorstwa"
        },
        "first step": {
          "content": "Przed dodaniem karty firmowej w aplikacji TachoSync upewnij się, że pobrałeś i zainstalowałeś aplikację Company Card Authenticator. Można to zrobić w dowolnym momencie w menu Ustawienia.\n\nAplikacja Company Card Authenticator odczyta i wyświetli informacje z kart prxedsiębiorstwa włożonych do czytnika kart oraz umożliwi zdalne uwierzytelnianie.\n\nKliknij „Rozpocznij”, aby zacząć.",
          "title": "Autentyfikator karty przedsiębiorstwa"
        },
        "fourth step": {
          "content": "Po prawej stronie znajduje się panel z danymi firmy. Znajdziesz tu wszystkie informacje dotyczące utworzonej firmy.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować.",
          "title": "Dane firmy"
        },
        "second step": {
          "content": "Korzystając z lewego paska bocznego, przejdź do zaznaczonej strony <strong>Firmy</strong>.",
          "title": "Strona firm"
        },
        "third step": {
          "content": "Aby wyświetlić ekran z kartami przedsiębiorstw, należy najpierw kliknąć jedną z firm.",
          "title": "Wybierz firmę"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Aby dodać nową kartę przedsiębiorstwa, kliknij podświetlony przycisk „Dodaj nową”. Gdy pojawi się ekran dodawania firmy, wypełnij wymagane pola i kliknij przycisk „Zapisz”, aby zakończyć.\n\nUwaga: Identyfikator karty przedsiębiorstwa można znaleźć w aplikacji Company Card Authenticator, w kolumnie „Identyfikator karty”.\n\nKliknij „<strong>D</strong>ale<strong>j</strong>”, aby kontynuować.",
          "title": "Dodaj nową kartę przedsiębiorstwa"
        },
        "final step": {
          "content": "Wszystkie dodane karty zostaną wyświetlone w sekcji „Karty przedsiębiorstwa” zaznaczonej na żółto. Znajdziesz tam status karty, datę ważności oraz identyfikator.",
          "title": "Dane karty przedsiębiorstwa"
        },
        "first step": {
          "content": "Najpierw musimy przejść do <strong>strony</strong> <strong>Firmy</strong>, która znajduje się w menu w prawym górnym rogu.\n\nKliknij podświetlony obszar, aby otworzyć <strong>menu</strong>.",
          "title": "Otwórz menu"
        },
        "fourth step": {
          "content": "Tutaj znajdziesz wszystkie informacje dotyczące utworzonej firmy.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować.",
          "title": "Dane firmy"
        },
        "second step": {
          "content": "Aby otworzyć <strong>stronę</strong> <strong>Firmy</strong>, kliknij podświetlony obszar.",
          "title": "Strona firm"
        },
        "third step": {
          "content": "Tutaj można zobaczyć listę wszystkich firm.\nAby wyświetlić kartę danego przedsiębiorstwa, należy otworzyć ekran <strong>szczegółów firmy</strong>, klikając podświetlony przycisk.",
          "title": "Więcej szczegółów"
        }
      },
      "name": "Dodaj kartę przedsiębiorstwa"
    },
    "add vehicle": {
      "first step": {
        "content": "Aby zastosować harmonogram, musisz dodać co najmniej jeden pojazd.\n\nDodajmy pojazd, naciskając podświetlony przycisk „Dodaj<strong> </strong>pojazd”.\n\nNa następnym ekranie wypełnij wszystkie wymagane pola i naciśnij przycisk <strong>„</strong>Dodaj”, aby zakończyć dodawanie pojazdu.",
        "title": "Nie dodano żadnych pojazdów"
      },
      "name": "Dodaj pojazd"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Po wybraniu harmonogramu przycisk „Zastosuj” stanie się aktywny.\n\nKliknij przycisk „Zastosuj”.\n\nKliknij „Dalej”, aby kontynuować.",
          "title": "Wybierz harmonogram, który chcesz zastosować"
        },
        "final step": {
          "content": "Po pomyślnym zastosowaniu harmonogramu do pojazdu rozpocznie się pobieranie danych zgodnie z zaplanowanym czasem.\n\nWszystkie harmonogramy zastosowane do pojazdu lub kierowcy zostaną wyświetlone w podświetlonym panelu „Więcej szczegółów”.\n\nKliknij <strong>„Zakończ</strong>”, aby zakończyć samouczek.",
          "title": "Harmonogram został pomyślnie zastosowany"
        },
        "first step": {
          "content": "Harmonogramy pojazdów znajdują się na stronie Pojazdy, natomiast harmonogramy kierowców znajdują się na stronie Kierowcy.\n\nPonieważ proces jest podobny na obu stronach, w tym samouczku wybierz podświetloną stronę <strong>„Pojazdy</strong>”.",
          "title": "Harmonogram pojazdów lub kierowców"
        },
        "fourth step": {
          "content": "Kliknij harmonogram, aby zastosować go do wybranych pojazdów.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować",
          "title": "Wybierz harmonogram, który chcesz zastosować"
        },
        "second step": {
          "content": "Przed zastosowaniem harmonogramu wybierz jeden lub więcej pojazdów.\n\nW tym samouczku wybierz <strong>pierwszy pojazd w tabeli</strong>, klikając podświetlony przycisk.",
          "title": "Wybierz pojazd"
        },
        "third step": {
          "content": "Po wybraniu pojazdu przycisk „Harmonogramy” stanie się aktywny.\n\nKliknij podświetlony przycisk <strong>„Harmonogramy</strong>”, aby kontynuować.",
          "title": "Otwarte harmonogramy"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Po wybraniu pojazdu przycisk „Harmonogramy” powinien zostać podświetlony.\n\nKliknij podświetlony przycisk <strong>„Harmonogramy</strong>”, aby kontynuować.",
          "title": "Otwarte harmonogramy"
        },
        "final step": {
          "content": "Po pomyślnym zastosowaniu harmonogramu do pojazdu rozpocznie się pobieranie danych zgodnie z zaplanowanym czasem.\nWszystkie harmonogramy zastosowane do pojazdu lub kierowcy zostaną wyświetlone w podświetlonym panelu „<strong>Więcej </strong>szczegółów”.\n\nKliknij <strong>„Zakończ</strong>”, aby zakończyć samouczek.",
          "title": "Harmonogram został pomyślnie zastosowany"
        },
        "first step": {
          "content": "Harmonogramy pojazdów znajdują się na stronie Pojazdy, natomiast harmonogramy kierowców znajdują się na stronie Kierowcy.\n\nPonieważ proces jest podobny na obu stronach, w tym samouczku wybierzmy zaznaczoną <strong>„stronę Pojazdy</strong>”.",
          "title": "Harmonogram pojazdów lub kierowców"
        },
        "fourth step": {
          "content": "W tym samouczku wybierzmy pierwszy pojazd w tabeli, klikając podświetlony przycisk.",
          "title": "Wybierz pojazd"
        },
        "second step": {
          "content": "Ponieważ proces jest podobny na obu stronach, w tym samouczku wybierzmy zaznaczoną <strong>„Stronę pojazdów</strong>”.",
          "title": "Strona pojazdów"
        },
        "seventh step": {
          "content": "Po wybraniu harmonogramu podświetlony przycisk „<strong>Zastosuj</strong>” stanie się aktywny. Kliknięcie go spowoduje zastosowanie harmonogramu do wybranego pojazdu.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować.",
          "title": "Wybierz harmonogram, który chcesz zastosować"
        },
        "sixth step": {
          "content": "Po wybraniu pojazdu możesz wybrać harmonogram, który chcesz zastosować, klikając na niego.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować",
          "title": "Wybierz harmonogram, który chcesz zastosować"
        },
        "third step": {
          "content": "Przed zastosowaniem harmonogramu do pojazdów należy najpierw wybrać co najmniej jeden pojazd.\nAby rozpocząć, kliknij podświetlony przycisk „<strong>Wybierz </strong>wiersze”.",
          "title": "Otwórz narzędzie do wyboru"
        }
      },
      "name": "Zastosuj harmonogram"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "W górnym menu selektor firm umożliwia wybranie firmy, z którą chcesz współpracować w TachoSync.\nJest to konieczne, gdy zarządzasz więcej niż jedną firmą.\n\nKliknij <strong>podświetlony</strong> przycisk, aby otworzyć selektor firm.",
          "title": "Otwórz selektor firm"
        },
        "second step": {
          "content": "Ekran wyboru firmy pozwala wybrać konkretną firmę, z którą chcesz pracować. W pozostałych menu będą widoczne wyłącznie zasoby związane z wybraną firmą. Wylogowanie się z TachoSync zawsze zapisuje ostatnio używany wybór.",
          "title": "Wybór firmy"
        }
      },
      "mobile": {
        "first step": {
          "content": "W górnym menu selektor firm umożliwia wybranie firmy, z którą chcesz współpracować w TachoSync.\nJest to konieczne, gdy zarządzasz więcej niż jedną firmą.\n\nKliknij <strong>podświetlony</strong> przycisk, aby otworzyć selektor firm.",
          "title": "Otwórz selektor firm"
        },
        "second step": {
          "content": "Ekran wyboru firmy pozwala wybrać konkretną firmę, z którą chcesz pracować. W pozostałych menu będą widoczne wyłącznie zasoby związane z wybraną firmą. Wylogowanie się z TachoSync zawsze zapisuje ostatnio używany wybór.",
          "title": "Wybór firmy"
        }
      },
      "name": "Wybór firmy"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Po utworzeniu harmonogramu należy go zastosować do wybranych pojazdów lub kierowców. Informacje na temat stosowania harmonogramów można znaleźć w samouczku „Zastosuj<strong> </strong>harmonogram”.\n\nKliknij „Dale<strong>j</strong>”, aby kontynuować.",
          "title": "Harmonogram nie ma zastosowania"
        },
        "final step": {
          "content": "Gratulacje, nauczyłeś się, jak utworzyć harmonogram.\n\nNastępnie dowiedz się, jak zastosować harmonogram do wybranych pozycji.\n\nKliknij <strong>„Zakończ</strong>”, aby zakończyć samouczek.",
          "title": "Utwórz harmonogram – zakończono"
        },
        "first step": {
          "content": "Harmonogram to z góry ustalony plan, który automatycznie pobiera dane z tachografów pojazdów lub kierowców w określonych momentach i odstępach czasu. Dzięki ustawieniu daty rozpoczęcia, godziny i częstotliwości (np. codziennie) harmonogram zapewnia regularne gromadzenie danych bez konieczności wykonywania czynności ręcznych.\n\nKliknij „<strong>Rozpocznij</strong>”, aby zacząć.",
          "title": "Czym jest harmonogram?"
        },
        "fourth step": {
          "content": "Na tym ekranie można tworzyć, edytować, wstrzymywać lub usuwać harmonogramy. Pierwsze miejsce jest zawsze zarezerwowane dla harmonogramu globalnego, którego nie można usunąć.",
          "title": "Harmonogramy"
        },
        "second step": {
          "content": "Harmonogramy pojazdów znajdują się na stronie „Pojazdy”. Harmonogramy kierowców znajdują się na stronie „Kierowcy”.\n\nPonieważ proces jest podobny na obu stronach, w tym samouczku wybierz podświetloną stronę <strong>„Pojazdy</strong>”.",
          "title": "Harmonogram pojazdów lub kierowców"
        },
        "third step": {
          "content": "Harmonogram można utworzyć i edytować w oknie Harmonogramy w dowolnym momencie, niezależnie od tego, czy dodano już pojazdy lub kierowców.\n\nKliknij podświetlony przycisk „<strong>Harmonogramy</strong>”, aby kontynuować.",
          "title": "Otwarte harmonogramy"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Na tym ekranie można tworzyć, edytować, wstrzymywać lub usuwać dowolne utworzone harmonogramy. Pierwsze miejsce jest zawsze zarezerwowane dla harmonogramu globalnego, którego nie można usunąć.",
          "title": "Harmonogramy"
        },
        "final step": {
          "content": "Gratulacje, udało Ci się nauczyć tworzenia harmonogramu.\n\nDalej, dowiedz się, jak zastosować harmonogram do wybranych elementów.\n\nKliknij <strong>„Zakończ</strong>”, aby zakończyć samouczek.",
          "title": "Utwórz harmonogram – zakończono"
        },
        "first step": {
          "content": "Harmonogram to z góry ustalony plan, który automatycznie pobiera dane z tachografów pojazdów lub kierowców w określonych momentach i odstępach czasu. Dzięki ustawieniu daty rozpoczęcia, godziny i częstotliwości (np. codziennie) harmonogram zapewnia regularne gromadzenie danych w automatyczny sposób.\n\nKliknij „<strong>Rozpocznij</strong>”, aby zacząć.",
          "title": "Czym jest harmonogram?"
        },
        "fourth step": {
          "content": "Harmonogram można utworzyć i edytować w oknie Harmonogramy w dowolnym momencie, niezależnie od tego, czy dodano już pojazdy lub kierowców.\n\nKliknij podświetlony przycisk „<strong>Harmonogramy</strong>”, aby kontynuować.",
          "title": "Otwarte harmonogramy"
        },
        "second step": {
          "content": "Harmonogramy pojazdów znajdują się na stronie Pojazdy, natomiast harmonogramy kierowców znajdują się na stronie Kierowcy.\n\n Aby przejść do tych stron, najpierw otwórzmy <strong>menu</strong>.",
          "title": "Harmonogram pojazdów lub kierowców"
        },
        "sixth step": {
          "content": "Po utworzeniu harmonogramu należy go zastosować do wybranych pojazdów lub kierowców. Sposób wykonania tej czynności wyjaśniono w innym samouczku „Zastosuj<strong> harmonogram</strong>”.\n\nKliknij <strong>„Dalej</strong>”, aby kontynuować.",
          "title": "Harmonogram nie ma zastosowania"
        },
        "third step": {
          "content": "Ponieważ proces jest podobny na obu stronach, w tym samouczku wybierzmy zaznaczoną „Stronę <strong>pojazdów</strong>”",
          "title": "Strona pojazdów"
        }
      },
      "name": "Utwórz harmonogram"
    }
  }
}
